import i18n from '../i18n';
import _get from 'lodash/get';
import smbUtils from '../smbUtils';

const advSkinDetectionCategories = [
  {
    disabled: false,
    value: 'firmness',
    value_v2: 'firmness',
    value_v2_hd: 'hd_firmness',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.firmness',
      'Firmness'
    ),
    labelI18n: {
      en: 'Firmness',
      fr: 'Fermeté',
      ja: 'ハリ',
      'zh-Hant': '緊緻度',
      'zh-Hans': '紧致度',
      ko: '견고함',
      de: 'Festigkeit',
      es: 'Firmeza',
      it: 'Tonicità',
      pt: 'Firmeza',
      ar: 'شد البشرة',
    },
    desc: {
      en:
        'AI algorithm analyzes skin firmness and identifies levels of skin sagging on both sides of the chin.',
      fr:
        "Notre algorithme en IA évalue l'affaissement de la peau au niveau des paupières supérieures, inférieures et autour du menton.",
      ja:
        'AI アルゴリズムは、肌のハリを分析し、顎の両側のたるみ状態を識別します。',
      cht: 'AI 演算法能分析肌膚緊緻度並檢測下巴兩側皮膚的下垂程度。',
      chs: 'AI 算法分析皮肤紧致度，并确定下巴两侧皮肤的下垂程度。',
      ko:
        'AI 알고리즘이 피부 탄력을 분석하고 턱 양쪽의 피부 처짐 정도를 확인합니다.',
      de:
        'Der KI-Alogrithnus analysiert die Festigkeit der Haut und identifiziert, wie sehr die Haut bereits hängt.',
      es:
        'El algoritmo de IA analiza la flacidez facial e identifica los niveles de flacidez de la piel en ambos lados del mentón.',
      it:
        'L’algoritmo AI analizza la compattezza della pelle e identifica i livelli di cedimento della pelle su entrambi i lati del mento.',
      pt:
        'O algoritmo de IA analisa a firmeza da pele e identifica os níveis de flacidez da pele em ambos os lados do queixo.',
    },
    resultDesc: {
      enu: {
        good: "You're looking as youthful and glowy as ever. Keep it up!",
        average:
          'A gentle massage of your face will help to lift and sculpt your skin, stimulating muscles that will improve your overall skin volume and appearance.',
        notGood:
          'In need of a skincare boost? Try a collagen-boosting mask to help to restore volume and firmness to your skin.',
      },
      fra: {
        good:
          'Votre peau est plus jeune et lumineuse que jamais. Continuez comme ça!',
        average:
          "Un massage léger du visage aidera à raffermir et sculpter la peau, en stimulant les muscles qui améliorent le volume et l'apparence de la peau.",
        notGood:
          "Votre peau a besoin d'un boost de soin ? Essayez un masque au collagène pour restorer son volume et sa fermeté.",
      },
      jpn: {
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        average:
          '顔を優しくマッサージすることで、肌をリフトアップします。また、筋肉を刺激することで、肌全体のボリュームをアップさせ、見た目の印象を良くします。',
        notGood:
          'コラーゲンが配合されたフェイスパックでたるみを防ぎ、お肌に弾力とハリを与えましょう。',
      },
      cht: {
        good:
          '整體輪廓緊緻有彈性，努力維持膠原蛋白在最佳狀態。同樣記得防曬避免膠原提早流失，日常則是多補充維他命C含量高的蔬果，保養重視保濕，擦保養品時可搭配輪廓線的拉提按摩。',
        average:
          '眼瞼下垂、臉頰或嘴角下垂，五官沒有之前立體了。由於人體的含水量超過60％，其中15％集中在肌膚，最重要的護膚守則之一救是每日都要飲用足夠的水，除了日常的保濕保養外，每周2~3次可交替使用保濕與拉提緊緻面膜。',
        notGood:
          '連頸部肌膚都開始下垂或紋路增加（俗稱火雞脖子），再不努力就來不及了！優質睡眠，搭配睡前的紫外線修護調理，讓夜晚肌膚黃金修復期得以發揮最好的運作，也能適當使用喜愛的精油增加睡眠品質。',
      },
      chs: {
        good:
          '整体轮廓紧致有弹性，努力维持胶原蛋白在最佳状态。同样记得防晒避免胶原提早流失，日常则是多补充维他命C含量高的蔬果，保养重视保湿，擦保养品时可搭配轮廓线的拉提按摩。',
        average:
          '眼睑下垂、脸颊或嘴角下垂，五官没有之前立体了。由于人体的含水量超过60％，其中15％集中在肌肤，最重要的护肤守则之一救是每日都要饮用足够的水，除了日常的保湿保养外，每周2~3次可交替使用保湿与拉提紧致面膜。',
        notGood:
          '连颈部肌肤都开始下垂或纹路增加（俗称火鸡脖子），再不努力就来不及了！优质睡眠，搭配睡前的紫外线修护调理，让夜晚肌肤黄金修复期得以发挥最好的运作，也能适当使用喜爱的精油增加睡眠质量。',
      },
    },
  },
  {
    disabled: false,
    value: 'droopy_upper_eyelid',
    value_v2: 'droopy_upper_eyelid',
    value_v2_hd: 'hd_droopy_upper_eyelid',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.droopy.upper.eyelid',
      'Droopy Upper Eyelid'
    ),
    labelI18n: {
      en: 'Droopy Upper Eyelid',
      fr: 'Paupière supérieure tombante',
      ja: '上まぶたのたるみ',
      'zh-Hant': '上眼瞼鬆弛',
      'zh-Hans': '上眼睑松弛',
      ko: '윗 눈꺼풀 처짐',
      de: 'Schlaffes oberes Augenlid',
      es: 'Párpado superior caído',
      it: 'Palpebra Superiore Cadente',
      pt: 'Pálpebra superior caída',
      ar: 'تدلي الجفن العلوي',
    },
    desc: {
      en:
        'AI algorithm examines the outer corner of the upper eyelid and identifies levels of sagging around it for one/both eyes.',
      fr:
        "L'algorithme en IA examine le coin extérieur de la paupière supérieure afin d'identifier l'affaissement à ce niveau.",
      ja:
        'AI アルゴリズムは、上まぶたの目尻を調べ、片眼/両眼の周りのたるみ状態を識別します。',
      cht: 'AI 演算法能分析至上眼瞼外側，並辨識出單眼/雙眼周圍的眼瞼下垂程度。',
      chs: 'AI 算法可检查上眼皮的外眼角，并确定单/双眼的下垂程度。',
      ko:
        'AI 알고리즘이 위 눈꺼풀의 바깥쪽 모서리를 분석하여 한쪽 또는 양쪽 눈의 눈꺼풀 주위에 처지는 정도를 식별합니다.',
      de:
        'Der KI-Algorithmus untersucht die äußere Ecke des oberen Augenlids und stellt fest, wie sehr die Haut darum herum an einem/beiden Auge/n hängt.',
      es:
        'El algoritmo de IA examina la esquina exterior del párpado superior e identifica los niveles de flacidez a su alrededor para uno o ambos ojos.',
      it:
        'L’algoritmo di AI esamina l’angolo esterno della palpebra superiore e identifica i livelli di rilassamento intorno a essa per uno/entrambi gli occhi.',
      pt:
        'O algoritmo de IA examina o canto externo da pálpebra superior e identifica os níveis de flacidez ao redor para um/ambos os olhos.',
    },
    resultDesc: {
      enu: {
        good:
          'Hey there good looking! Tell us all your skincare secrets- your skin is looking good.',
        average:
          'In need of a little lift? Place.two chilled cucumber slices over eyes for 10-20 minutes to naturally tighten skin and improve sagging.',
        notGood:
          'Look for products with resveratrol which naturally help to slow cell aging and keep skin looking tigh and lifted.',
      },
      fra: {
        good: 'Dites-nous tous vos secrets pour cette peau resplendissante!',
        average:
          "Besoin d'un petit lifting? Placez deux concombres froids sur vos yeux pendant 10 à 20 minutes pour raffermir votre peau et ralentir l'affaissement.",
        notGood:
          'Trouvez des produits contenant de resveratrol qui aide naturellement à ralentir le veillissement des cellules et à garder la peau ferme.',
      },
      jpn: {
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        average:
          'リフトアップが必要です。冷やしたきゅうりの輪切り2枚を目の上に10～20分置くと、肌が自然に引き締まり、たるみが改善されます。',
        notGood:
          'レスベラトロールが配合された製品は、細胞の老化を遅らせ、肌の弾力を改善する効果が期待されています。',
      },
      cht: {
        good:
          '20～35歲之間，通常是因為水腫出現的眼皮鬆弛下垂，透過具排水功能的眼部保養系列多半可以獲得改善，記得擦眼霜的時候不要過度拉扯，使用3C產品的時間也不要過長，用眼過度也會造成眼周肌肉的負擔。',
        average:
          '40歲之後出現的眼皮鬆弛下垂不外乎就是老化問題，但眼瞼鬆弛的程度與速度與體質及保養習慣有很大的關聯。改用較為滋潤的眼霜持續呵護之外，白天出門的防曬也別忘記眼周部位，以避免紫外線加速光老化速度。',
        notGood:
          '眼角明顯鬆弛甚至改變眼型，用分子細小的胜肽類保養品，或添加左旋C及其他抗氧化成分的眼部產品，可以透過按摩達到眼皮提拉的效果，並促進眼周的微循環，進而消除眼皮浮腫與鬆弛。',
      },
      chs: {
        good:
          '20～35岁之间，通常是因为水肿出现的眼皮松弛下垂，通过有去水肿功能的眼部保养产品多半可以获得改善，记得擦眼霜的时候不要过度拉扯，使用3C产品的时间也不要过长，用眼过度也会造成眼周肌肉的负担。',
        average:
          '40岁之后出现的眼皮松弛下垂不外乎就是老化问题，但眼睑松弛的程度与速度与体质及保养习惯有很大的关联。除了改用较为滋润的眼霜持续呵护之外，白天出门的防晒也别忘记眼周部位，以避免紫外线加速光老化速度。',
        notGood:
          '眼角明显松弛甚至改变眼型，用分子细小的胜肽类保养品，或添加左旋C及其他抗氧化成分的眼部产品，可以透过按摩达到眼皮提拉的效果，并促进眼周的微循环，进而消除眼皮浮肿与松弛。',
      },
    },
  },
  {
    disabled: false,
    value: 'droopy_lower_eyelid',
    value_v2: 'droopy_lower_eyelid',
    value_v2_hd: 'hd_droopy_lower_eyelid',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.droopy.lower.eyelid',
      'Droopy Lower Eyelid'
    ),
    labelI18n: {
      en: 'Droopy Lower Eyelid',
      fr: 'Paupière inférieure tombante',
      ja: '下まぶたのたるみ',
      'zh-Hant': '下眼瞼鬆弛',
      'zh-Hans': '下眼睑松弛',
      ko: '아랫 눈꺼풀 처짐',
      de: 'Schlaffes unteres Augenlid',
      es: 'Párpado inferior caído',
      it: 'Palpebra Inferiore Cadente',
      pt: 'Pálpebra inferior caída',
      ar: 'تدلي الجفن السفلي',
    },
    desc: {
      en:
        'AI algorithm examines the outer corner of the lower eyelid and identifies levels of sagging around it for one/both eyes.',
      fr:
        "L'algorithme en IA examine le coin extérieur de la paupière inférieure afin d'identifier l'affaissement à ce niveau.",
      ja:
        'AI アルゴリズムは、下まぶたの目尻を調べ、片眼/両眼の周りのたるみ状態を識別します。',
      cht: 'AI 演算法能分析至下眼瞼外測，並辨識出單眼/雙眼周圍的眼瞼下垂程度。',
      chs: 'AI 算法分析皮肤紧致度，并确定下眼睑两侧皮肤的下垂程度。',
      ko:
        'AI 알고리즘이 아랫눈꺼풀의 바깥쪽 모서리를 분석하여 한쪽 또는 양쪽 눈의 눈꺼풀 주위에 처지는 정도를 식별합니다.',
      de:
        'Der KI-Algorithmus untersucht die äußere Ecke des unteren Augenlids und stellt fest, wie sehr die Haut darum herum an einem/beiden Auge/n hängt.',
      es:
        'El algoritmo de IA examina la esquina exterior del párpado inferior e identifica los niveles de flacidez a su alrededor para uno o ambos ojos.',
      it:
        'L’algoritmo di AI esamina l’angolo esterno della palpebra inferiore e identifica i livelli di cedimento intorno a essa per uno/entrambi gli occhi.',
      pt:
        'O algoritmo de IA examina o canto externo da pálpebra inferior e identifica os níveis de flacidez ao redor para um/ambos os olhos.',
    },
    resultDesc: {
      enu: {
        good:
          'Hey there good looking! Tell us all your skincare secrets- your skin is looking good.',
        average:
          'In need of a little lift? Place.two chilled cucumber slices over eyes for 10-20 minutes to naturally tighten skin and improve sagging.',
        notGood:
          'Look for products with resveratrol which naturally help to slow cell aging and keep skin looking tigh and lifted.',
      },
      fra: {
        good: 'Dites-nous tous vos secrets pour cette peau resplendissante!',
        average:
          "Besoin d'un petit lifting? Placez deux concombres froids sur vos yeux pendant 10 à 20 minutes pour raffermir votre peau et ralentir l'affaissement.",
        notGood:
          'Trouvez des produits contenant de resveratrol qui aide naturellement à ralentir le veillissement des cellules et à garder la peau ferme.',
      },
      jpn: {
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        average:
          'リフトアップが必要です。冷やしたきゅうりの輪切り2枚を目の上に10～20分置くと、肌が自然に引き締まり、たるみが改善されます。',
        notGood:
          'レスベラトロールが配合された製品は、細胞の老化を遅らせ、肌の弾力を改善する効果が期待されています。',
      },
      cht: {
        good:
          '沒有細紋也沒有淚溝的飽滿好膚質，選擇質地清爽的眼部精華或是凝露狀產品維持眼周肌膚的保水度，不熬夜也不要經常搓揉眼睛就能擁有電眼明眸。',
        average:
          '眼尾的緊緻度稍嫌不足，塗抹眼部保養品時以水平方向擦拭且力道也要相當輕柔，周間可輔以較潤澤的美容油搭配拉提按摩幫助恢復線條的緊緻度。',
        notGood:
          '出現了明顯的淚溝與紋路，代表眼周保養力度不足，飲食方面多攝取豐富維他命Ｃ含量的蔬果，有助於肌底組織更健康。選擇抗氧化效果強的胜肽成分眼霜或可刺激膠原增生的保養品更符合需求。',
      },
      chs: {
        good:
          '没有细纹也没有泪沟的饱满好肤质，选择质地清爽的眼部精华或是凝露状产品维持眼周肌肤的保水度，不熬夜也不要经常搓揉眼睛就能拥有电眼明眸。',
        average:
          '眼尾的紧致度稍显不足，涂抹眼部保养品时以水平方向擦拭且力道也要相当轻柔，周间可辅以较润泽的美容油搭配拉提按摩帮助恢复线条的紧致度。',
        notGood:
          '出现了明显的泪沟与纹路，代表眼周保养力度不足，饮食方面多摄取丰富维他命Ｃ含量的蔬果，有助于肌底组织更健康。选择抗氧化效果强的胜肽成分眼霜或可刺激胶原增生的保养品更符合需求。',
      },
    },
  },
  {
    disabled: false,
    value: 'acne',
    value_v2: 'acne',
    value_v2_hd: 'hd_acne',
    i18n: i18n.acne,
    label: i18n.t('u.c.skin.detection.categories.i.skincare.acne', 'Acne'),
    labelI18n: {
      en: 'Acne',
      fr: 'Acné',
      ja: 'ニキビ',
      'zh-Hant': '面皰',
      'zh-Hans': '痘痘',
      ko: '여드름',
      de: 'Akne',
      es: 'Acné',
      it: 'Acne',
      pt: 'Acne',
      ar: 'حبوب شباب',
    },
    desc: {
      en:
        'The algorithm can do a 180-degree full face analysis to identify three types of acne: inflammatory acne, whiteheads, and blackheads.',
      fr:
        "Notre algorithme analyse la peau de visage à 180° pour identifier 3 types d'acné : l'acné inflammatoire, les points blancs et les points noirs.",
      ja:
        'このアルゴリズムは、180度のフルフェイス分析を行い、炎症性吹き出物、白ニキビ、黒ずみという3種類のニキビを特定します。',
      cht:
        'AI 演算法能進行 180 度的全臉分析，辨別三種類型的面皰：發炎性青春痘、白頭粉刺和黑頭粉刺。',
      chs:
        'AI 算法可以做 180 度的全脸分析，识别三种类型的痤疮：炎症性痤疮、白头粉刺和黑头粉刺。',
      ko:
        '해당 알고리즘은 얼굴 전체를 180도 분석하여 염증성 여드름, 화이트헤드, 블랙헤드와 같은 세 가지 여드름 타입을 식별합니다.',
      de:
        'DDer Algorithmus kann eine 180°-Vollgesichtsanalyse durchführen, um drei Arten von Akne zu entdecken: Entzündliche Akne, Pickel und Mitesser.',
      es:
        'El diagnostico piel de 180 grados se aplica en toda la cara para identificar tres tipos de acné: acné inflamatorio, puntos blancos y puntos negros.',
      it:
        'Skin test viso a 180 gradi dei problemi di acne per identificarne diversi fattori e condizioni, tra cui iperpigmentazione post-infiammatoria (PIH), reazioni infiammatorie e punti neri.',
      pt:
        'O algoritmo pode fazer uma análise facial completa de 180 graus para identificar três tipos de acne: acne inflamatória, espinhas e cravos.',
    },
    resultDesc: {
      enu: {
        good:
          "Keep your hands off your face and don't forget your daily SPF and moisturizer to keep your clear skin pampered and protected.",
        average:
          "Be gentle with your skin and keep it clean and hydrated. Hyrdation helps to re-balance skin's oil glands to control acne and improve healing.",
        notGood:
          "Hands off your face! Focus on keeping skin clean with a gentle cleanser and replenishing moisture with a lightweight moisturizer that won't clog pores. Don't forget to clean your makeup brushes too.",
      },
      fra: {
        good:
          "Ne touchez pas votre visage et n'oubliez pas de protéger votre peau et de la garder hydratée pour une peau propre et protégée.",
        average:
          "Soyez doux avec votre peau et gardez la propre et hydratée. L'hydratation aide à ré-équilibrer la peau grasse et à contrôler l'acné tout en la soignant.",
        notGood:
          "Ne touchez pas votre visage! Concentrez-vous sur la façon de garder une peau propre et une hydratation fluide qui ne bouchera pas nos pores. N'oubliez pas de nettoyer vos pinceaux.",
      },
      jpn: {
        good:
          '肌は清潔です。その状態を保つために手で顔に触れず、毎日の保湿と日焼け対策を忘れないでください。',
        average:
          '肌を清潔に、保湿状態を保ってください。保湿は肌の油腺のバランスを整え、ニキビを抑制し、治癒力を高めます。',
        notGood:
          '手がなるべく顔に触れないようにしてください。肌に優しい洗顔料で清潔に保ち、毛穴を詰まらせない軽いテクスチャーの保湿剤で水分を補給しましょう。メイクブラシのお手入れも忘れずに。',
      },
      cht: {
        good:
          '幾乎看不見毛孔，讓人羨慕的光滑平整肌！做好每天的卸妝與清潔，並注意肌膚表面的油水平衡，但不要過度的清潔或是頻繁的使用吸油產品，以免肌膚過度分泌皮脂反而造成痘痘問題。',
        average:
          '出現痘痘蹤跡但沒有紅疹現象，那就是粉刺，粉刺型青春痘通常使用含A酸的保養品就可以達到不錯的控制效果。但初期使用Ａ酸可能會有刺激性，且當照射陽光刺激性會加劇，建議晚上使用即可，白天的防曬品也要選擇質地清爽的。',
        notGood:
          '膿皰型青春痘，甚至還伴隨嚴重的紅腫，表示發炎感染已經到達真皮層，留下痘疤的機率相當高。口服及外用A酸並行是最有效，另外，像果酸、杏仁酸、杜鵑花酸這類成也可輔助使用，但嚴重面皰問題絕對建議請教專業皮膚科醫師一起解決！',
      },
      chs: {
        good:
          '几乎看不见毛孔，让人羡慕的光滑平整肌！做好每天的卸妆与清洁，并注意肌肤表面的油水平衡，但不要过度的清洁或是频繁的使用吸油产品，以免肌肤过度分泌皮脂反而造成痘痘问题。',
        average:
          '出现痘痘踪迹但没有红疹现象，那就是粉刺，粉刺型青春痘通常使用含A酸的保养品就可以达到不错的控制效果。但初期使用Ａ酸可能会有刺激性，且当照射阳光刺激性会加剧，建议晚上使用即可，白天的防晒品也要选择质地清爽的。',
        notGood:
          '脓疱型青春痘，甚至还伴随严重的红肿，表示发炎感染已经到达真皮层，留下痘疤的机率相当高。口服及外用A酸并行是最有效，另外，像果酸、杏仁酸、杜鹃花酸这类成也可辅助使用，但严重面疱问题绝对建议请教专业皮肤科医师一起解决！',
      },
    },
  },
  {
    disabled: false,
    value: 'pore',
    value_v2: 'pore',
    value_v2_hd: 'hd_pore',
    label: i18n.t('u.c.skin.detection.categories.i.skincare.pore', 'Pore'),
    labelI18n: {
      en: 'Pore',
      fr: 'Pores visibles',
      ja: '毛穴',
      'zh-Hant': '毛孔',
      'zh-Hans': '毛孔',
      ko: '모공',
      de: 'Poren',
      es: 'Poros',
      it: 'Pori',
      pt: 'Poros',
      ar: 'المسام الواسعة',
    },
    desc: {
      en:
        "AI algorithm detects visible pores and highlights them with AR overlays. Pore analysis shows the condition of user's skin for the best treatment plan.",
      fr:
        "L'algorithme en IA détecte les pores et les montre en RA ce qui permet de proposer le meilleur traitement adapté à l'état de la peau.",
      ja:
        'AI アルゴリズムは目立つ毛穴を検出し、AR オーバーレイでハイライトします。.毛穴分析は、ユーザーの肌の状態を示し、トリートメントプランに役立ちます。',
      cht:
        'AI 演算法能檢測出可見毛孔，並使用 AR 疊加顯示出它們的位置。毛孔分析將顯示用戶的膚況，以提供最佳治療方案。',
      chs:
        'AI 算法可检测可见的毛孔，并通过 AR 叠加突出显示它们。毛孔分析显示用户的皮肤状况，以便制定最佳治疗方案。',
      ko:
        'AI 알고리즘이 피부 모공을 감지하고 AR 오버레이를 통해 모공을 강조합니다. 피부 상태를 시각화하여 효과적인 피부 타입 진단을 도출합니다.',
      de:
        'Der KI-Algorithmus entdeckt sichtbare Poren und betont sie mit AR-Überlagerungen. Porenanalyse zeigt den Zustand der Haut einer Nutzerin/eines Nutzers für den besten Behandlungsplan.',
      es:
        'El algoritmo de IA detecta los poros vde la piel isibles y los resalta con superposiciones de RA. El análisis de los poros de la piel muestra el estado de la piel del usuario para el mejor plan de tratamiento.',
      it:
        'Pori visibili L’algoritmo di AI rileva i pori visibili e li evidenzia con sovrapposizioni di AR. L’analisi dei pori mostra la condizione della pelle dell’utilizzatore per il miglior piano di trattamento.',
      pt:
        'Algoritmo de IA detecta poros visíveis e os destaca com sobreposições RA. A análise de poros mostra a condição da pele d@ usuári@ para um plano de tratamento adequado.',
    },
    resultDesc: {
      enu: {
        good:
          "Someone's mastered beautiful complexion! Keep up the great work.",
        average:
          'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
        notGood:
          'To help declog pores use a gentle cleanser twice daily and opt for non-comedogenic skin care and makeup products.',
      },
      fra: {
        good: 'Vous savez être maîtresse de votre teint. Continuez comme ça.',
        average:
          'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
        notGood:
          'Pour déboucher vos pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soin et pour du maquillage non-comédogènes.',
      },
      jpn: {
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        average:
          '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
        notGood:
          '1日2回、肌に優しい洗顔料で毛穴の汚れを落とし、ニキビになりにくいノンコメドジェニックのスキンケアや化粧品を選びましょう。',
      },
      cht: {
        good:
          '膚質看起來很精緻幾乎零毛孔，記得持續做好保濕與防曬，避免油脂過度堆積。愛曬太陽又不防曬的人毛孔絕對會越來越粗大，因為紫外線會破壞肌底膠原蛋白，使皮膚老化鬆弛，因此，一年四季都要擦防曬。',
        average:
          '油性肌膚出油過多與老廢角質堆積，固化的皮脂進而形成白頭與黑頭粉刺，毛囊內部因長期受到擠壓而顯得粗大。使用含適當濃度的酸類產品煥膚，發揮控油、代謝老化角質等作用便能改善毛孔粗大問題。',
        notGood:
          '除了痘疤還伴隨著老化型毛孔，尤其兩頰毛孔更為明顯，除了醫學美容之外，平日保養加強去角質等深層清潔，老化型毛孔則要更注意清潔之後的保濕，同時可使用含維他命A的保養品持續細緻粗大毛孔問題。',
      },
      chs: {
        good:
          '肤质看起来很精致几乎零毛孔，记得持续做好保湿与防晒，避免油脂过度堆积。爱晒太阳又不防晒的人毛孔绝对会越来越粗大，因为紫外线会破坏肌底胶原蛋白，使皮肤老化松弛，因此，一年四季都要擦防晒。',
        average:
          '油性肌肤出油过多与老废角质堆积，固化的皮脂进而形成白头与黑头粉刺，毛囊内部因长期受到挤压而显得粗大。使用含适当浓度的酸类产品焕肤，发挥控油、代谢老化角质等作用便能改善毛孔粗大问题。',
        notGood:
          '除了痘疤还伴随着老化型毛孔，尤其两颊毛孔更为明显，除了医学美容之外，平日保养加强去角质等深层清洁，老化型毛孔则要更注意清洁之后的保湿，同时可使用含维他命A的保养品持续细致粗大毛孔问题。',
      },
    },
    options: [
      {
        disabled: false,
        isRequired: true,
        value: 'hd_pore',
        value_v2_hd: 'hd_pore',
        label: i18n.t(
          'u.c.skin.detection.categories.i.skincare.pore.full.face.abbr',
          'Full Face'
        ),
        labelI18n: {
          en: 'Pores Full Face',
          fr: 'Pores du visage',
          ja: '毛穴の目立つ顔',
          'zh-Hant': '全臉粗大毛孔',
          'zh-Hans': '全脸毛孔',
          ko: '얼굴 전체 모공',
          de: 'Poren Vollgesicht',
          es: 'Poros en todo el rostro',
          it: 'Pori su tutto il viso',
          pt: 'Poros em todo o rosto',
          ar: 'مسام الوجه بالكامل',
        },
        desc: {
          en:
            "AI algorithm detects visible pores and highlights them with AR overlays. Pore analysis shows the condition of user's skin for the best treatment plan.",
          fr:
            "L'algorithme en IA détecte les pores et les montre en RA ce qui permet de proposer le meilleur traitement adapté à l'état de la peau.",
          ja:
            'AI アルゴリズムは目立つ毛穴を検出し、AR オーバーレイでハイライトします。.毛穴分析は、ユーザーの肌の状態を示し、トリートメントプランに役立ちます。',
          cht:
            'AI 演算法能檢測出可見毛孔，並使用 AR 疊加顯示出它們的位置。毛孔分析將顯示用戶的膚況，以提供最佳治療方案。',
          chs:
            'AI 算法可检测可见的毛孔，并通过 AR 叠加突出显示它们。毛孔分析显示用户的皮肤状况，以便制定最佳治疗方案。',
          ko:
            'AI 알고리즘이 피부 모공을 감지하고 AR 오버레이를 통해 모공을 강조합니다. 피부 상태를 시각화하여 효과적인 피부 타입 진단을 도출합니다.',
          de:
            'Der KI-Algorithmus entdeckt sichtbare Poren und betont sie mit AR-Überlagerungen. Porenanalyse zeigt den Zustand der Haut einer Nutzerin/eines Nutzers für den besten Behandlungsplan.',
          es:
            'El algoritmo de IA detecta los poros vde la piel isibles y los resalta con superposiciones de RA. El análisis de los poros de la piel muestra el estado de la piel del usuario para el mejor plan de tratamiento.',
          it:
            'Pori visibili L’algoritmo di AI rileva i pori visibili e li evidenzia con sovrapposizioni di AR. L’analisi dei pori mostra la condizione della pelle dell’utilizzatore per il miglior piano di trattamento.',
          pt:
            'Algoritmo de IA detecta poros visíveis e os destaca com sobreposições RA. A análise de poros mostra a condição da pele d@ usuári@ para um plano de tratamento adequado.',
        },
        resultDesc: {
          enu: {
            good:
              "Someone's mastered beautiful complexion! Keep up the great work.",
            average:
              'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
            notGood:
              'To help declog pores use a gentle cleanser twice daily and opt for non-comedogenic skin care and makeup products.',
          },
          fra: {
            good:
              'Vous savez être maîtresse de votre teint. Continuez comme ça.',
            average:
              'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
            notGood:
              'Pour déboucher vos pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soin et pour du maquillage non-comédogènes.',
          },
          jpn: {
            good:
              '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
            average:
              '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
            notGood:
              '1日2回、肌に優しい洗顔料で毛穴の汚れを落とし、ニキビになりにくいノンコメドジェニックのスキンケアや化粧品を選びましょう。',
          },
          cht: {
            good:
              '膚質看起來很精緻幾乎零毛孔，記得持續做好保濕與防曬，避免油脂過度堆積。愛曬太陽又不防曬的人毛孔絕對會越來越粗大，因為紫外線會破壞肌底膠原蛋白，使皮膚老化鬆弛，因此，一年四季都要擦防曬。',
            average:
              '油性肌膚出油過多與老廢角質堆積，固化的皮脂進而形成白頭與黑頭粉刺，毛囊內部因長期受到擠壓而顯得粗大。使用含適當濃度的酸類產品煥膚，發揮控油、代謝老化角質等作用便能改善毛孔粗大問題。',
            notGood:
              '除了痘疤還伴隨著老化型毛孔，尤其兩頰毛孔更為明顯，除了醫學美容之外，平日保養加強去角質等深層清潔，老化型毛孔則要更注意清潔之後的保濕，同時可使用含維他命A的保養品持續細緻粗大毛孔問題。',
          },
          chs: {
            good:
              '肤质看起来很精致几乎零毛孔，记得持续做好保湿与防晒，避免油脂过度堆积。爱晒太阳又不防晒的人毛孔绝对会越来越粗大，因为紫外线会破坏肌底胶原蛋白，使皮肤老化松弛，因此，一年四季都要擦防晒。',
            average:
              '油性肌肤出油过多与老废角质堆积，固化的皮脂进而形成白头与黑头粉刺，毛囊内部因长期受到挤压而显得粗大。使用含适当浓度的酸类产品焕肤，发挥控油、代谢老化角质等作用便能改善毛孔粗大问题。',
            notGood:
              '除了痘疤还伴随着老化型毛孔，尤其两颊毛孔更为明显，除了医学美容之外，平日保养加强去角质等深层清洁，老化型毛孔则要更注意清洁之后的保湿，同时可使用含维他命A的保养品持续细致粗大毛孔问题。',
          },
        },
      },
      {
        disabled: false,
        isRequired: false,
        value: 'hd_pore_forehead',
        value_v2_hd: 'hd_pore_forehead',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.pore.forehead.abbr',
          'Forehead'
        ),
        labelI18n: {
          en: 'Forehead',
          fr: 'Front',
          ja: '額の毛穴',
          'zh-Hant': '額頭',
          'zh-Hans': '前额',
          ko: '이마',
          de: 'Stirn',
          es: 'Frente',
          it: 'Fronte',
          pt: 'Testa',
          ar: 'جبهة',
        },
        desc: {
          en:
            'AI algorithm detects visible pores on the forehead, providing a severity score to help users recognize pore issues in this area.',
          fr:
            'L’algorithme d’IA détecte les pores visibles sur le front et fournit un score de gravité pour aider les utilisatrices à reconnaître les problèmes de pores dans cette zone.',
          ja:
            'AIのアルゴリズムがひたいにある目立ちやすい毛穴を見つけ、このエリアの毛穴について認識できるように点数をつけます。',
          cht:
            'AI 演算法能檢測額頭上的粗大毛孔，提供嚴重程度評分，幫助使用者辨識這個區域的毛孔問題。',
          chs:
            '人工智能算法可检测额头上的可见毛孔，并给出严重程度评分，帮助用户了解该部位的毛孔问题。',
          ko:
            'AI 알고리즘이 이마에서 눈에 띄는 모공을 감지하여 심각도 점수를 제공합니다. 이를 통해 사용자가 해당 부위의 모공 상태를 인지하고 관리할 수 있도록 돕습니다.',
          de:
            'Der KI-Algorithmus erkennt sichtbare Poren auf der Stirn und gibt einen Schweregrad an, der den Benutzern hilft, Porenprobleme in diesem Bereich zu erkennen.',
          es:
            'El algoritmo de IA detecta poros visibles en la frente, proporcionando una puntuación de seguridad para ayudar a los usuarios a reconocer problemas de poros en esta zona.',
          it:
            "L'algoritmo AI rileva i pori visibili sulla fronte, valutandoli in base a una scala che aiuta l'utente a comprendere la portata del problema nell'area.",
          pt:
            'O algoritmo de IA detecta poros visíveis na testa, fornecendo uma pontuação de gravidade ajudando os usuários a reconhecer problemas de poros nessa área.',
          ar:
            'تكتشف خوارزمية الذكاء الاصطناعي المسام المرئية على الجبهة، وتوفر درجة شدة لمساعدة المستخدمين على التعرف على مشاكل المسام في هذه المنطقة.',
        },
        resultDesc: {
          enu: {
            good:
              "Someone's mastered beautiful complexion! Keep up the great work.",
            average:
              'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
            notGood:
              'To help declog pores use a gentle cleanser twice daily and opt for non-comedogenic skin care and makeup products.',
          },
          fra: {
            good:
              'Vous savez être maîtresse de votre teint. Continuez comme ça.',
            average:
              'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
            notGood:
              'Pour déboucher vos pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soin et pour du maquillage non-comédogènes.',
          },
          jpn: {
            good:
              '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
            average:
              '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
            notGood:
              '1日2回、肌に優しい洗顔料で毛穴の汚れを落とし、ニキビになりにくいノンコメドジェニックのスキンケアや化粧品を選びましょう。',
          },
          cht: {
            good:
              '膚質看起來很精緻幾乎零毛孔，記得持續做好保濕與防曬，避免油脂過度堆積。愛曬太陽又不防曬的人毛孔絕對會越來越粗大，因為紫外線會破壞肌底膠原蛋白，使皮膚老化鬆弛，因此，一年四季都要擦防曬。',
            average:
              '油性肌膚出油過多與老廢角質堆積，固化的皮脂進而形成白頭與黑頭粉刺，毛囊內部因長期受到擠壓而顯得粗大。使用含適當濃度的酸類產品煥膚，發揮控油、代謝老化角質等作用便能改善毛孔粗大問題。',
            notGood:
              '除了痘疤還伴隨著老化型毛孔，尤其兩頰毛孔更為明顯，除了醫學美容之外，平日保養加強去角質等深層清潔，老化型毛孔則要更注意清潔之後的保濕，同時可使用含維他命A的保養品持續細緻粗大毛孔問題。',
          },
          chs: {
            good:
              '肤质看起来很精致几乎零毛孔，记得持续做好保湿与防晒，避免油脂过度堆积。爱晒太阳又不防晒的人毛孔绝对会越来越粗大，因为紫外线会破坏肌底胶原蛋白，使皮肤老化松弛，因此，一年四季都要擦防晒。',
            average:
              '油性肌肤出油过多与老废角质堆积，固化的皮脂进而形成白头与黑头粉刺，毛囊内部因长期受到挤压而显得粗大。使用含适当浓度的酸类产品焕肤，发挥控油、代谢老化角质等作用便能改善毛孔粗大问题。',
            notGood:
              '除了痘疤还伴随着老化型毛孔，尤其两颊毛孔更为明显，除了医学美容之外，平日保养加强去角质等深层清洁，老化型毛孔则要更注意清洁之后的保湿，同时可使用含维他命A的保养品持续细致粗大毛孔问题。',
          },
        },
      },
      {
        disabled: false,
        isRequired: false,
        value: 'hd_pore_nose',
        value_v2_hd: 'hd_pore_nose',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.nose.abbr',
          'Nose'
        ),
        labelI18n: {
          en: 'Nose',
          fr: 'Nez',
          ja: '鼻の毛穴',
          'zh-Hant': '鼻子',
          'zh-Hans': '鼻子',
          ko: '코',
          de: 'Nase',
          es: 'Nariz',
          it: 'Naso',
          pt: 'Nariz',
          ar: 'أنف',
        },
        desc: {
          en:
            'AI algorithm identifies visible pores on the nose, showing their severity and helping users recognize the condition of pores on this common trouble area.',
          fr:
            'L’algorithme d’IA identifie les pores visibles sur le nez, en montrant leur gravité et en aidant les utilisatrices à reconnaître l’état des pores sur cette zone à problèmes courante.',
          ja:
            'AIのアルゴリズムが鼻にある目立ちやすい毛穴を見つけ、問題が起きやすいこのエリアの毛穴について認識できるように点数をつけます。',
          cht:
            'AI 演算法能識別鼻子上的粗大毛孔，顯示其嚴重程度，幫助使用者了解這個常見問題區的毛孔狀況。',
          chs:
            '人工智能算法可识别鼻子上的明显毛孔，显示其严重程度，帮助用户了解这一常见问题部位的毛孔状况。',
          ko:
            'AI 알고리즘이 코에서 눈에 띄는 모공을 감지하여 심각도를 표시합니다. 이를 통해 사용자가 이 흔한 고민 부위의 모공 상태를 인식하고 관리할 수 있도록 돕습니다.',
          de:
            'Der KI-Algorithmus identifiziert sichtbare Poren auf der Nase, zeigt ihren Schweregrad an und hilft den Benutzern, den Zustand der Poren an dieser häufigen Problemzone zu erkennen.',
          es:
            'El algoritmo de IA identifica poros visibles en la nariz, mostrando su gravedad y ayudando a los usuarios a reconocer el estado de los poros en esta zona que suele ser problemática.',
          it:
            "L'algoritmo AI rileva i pori visibili sul naso, valutandoli in base a una scala che aiuta l'utente a comprendere la portata del problema, comune in quest'area.",
          pt:
            'O algoritmo de IA identifica os poros visíveis no nariz, mostrando sua gravidade e ajudando os usuários a reconhecer a condição dos poros nessa área comum de problemas.',
          ar:
            'تعمل خوارزمية الذكاء الاصطناعي على تحديد المسام المرئية على الأنف، مما يوضح شدتها ويساعد المستخدمين على التعرف على حالة المسام في منطقة المشاكل الشائعة هذه.',
        },
        resultDesc: {
          enu: {
            good:
              "Someone's mastered beautiful complexion! Keep up the great work.",
            average:
              'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
            notGood:
              'To help declog pores use a gentle cleanser twice daily and opt for non-comedogenic skin care and makeup products.',
          },
          fra: {
            good:
              'Vous savez être maîtresse de votre teint. Continuez comme ça.',
            average:
              'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
            notGood:
              'Pour déboucher vos pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soin et pour du maquillage non-comédogènes.',
          },
          jpn: {
            good:
              '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
            average:
              '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
            notGood:
              '1日2回、肌に優しい洗顔料で毛穴の汚れを落とし、ニキビになりにくいノンコメドジェニックのスキンケアや化粧品を選びましょう。',
          },
          cht: {
            good:
              '膚質看起來很精緻幾乎零毛孔，記得持續做好保濕與防曬，避免油脂過度堆積。愛曬太陽又不防曬的人毛孔絕對會越來越粗大，因為紫外線會破壞肌底膠原蛋白，使皮膚老化鬆弛，因此，一年四季都要擦防曬。',
            average:
              '油性肌膚出油過多與老廢角質堆積，固化的皮脂進而形成白頭與黑頭粉刺，毛囊內部因長期受到擠壓而顯得粗大。使用含適當濃度的酸類產品煥膚，發揮控油、代謝老化角質等作用便能改善毛孔粗大問題。',
            notGood:
              '除了痘疤還伴隨著老化型毛孔，尤其兩頰毛孔更為明顯，除了醫學美容之外，平日保養加強去角質等深層清潔，老化型毛孔則要更注意清潔之後的保濕，同時可使用含維他命A的保養品持續細緻粗大毛孔問題。',
          },
          chs: {
            good:
              '肤质看起来很精致几乎零毛孔，记得持续做好保湿与防晒，避免油脂过度堆积。爱晒太阳又不防晒的人毛孔绝对会越来越粗大，因为紫外线会破坏肌底胶原蛋白，使皮肤老化松弛，因此，一年四季都要擦防晒。',
            average:
              '油性肌肤出油过多与老废角质堆积，固化的皮脂进而形成白头与黑头粉刺，毛囊内部因长期受到挤压而显得粗大。使用含适当浓度的酸类产品焕肤，发挥控油、代谢老化角质等作用便能改善毛孔粗大问题。',
            notGood:
              '除了痘疤还伴随着老化型毛孔，尤其两颊毛孔更为明显，除了医学美容之外，平日保养加强去角质等深层清洁，老化型毛孔则要更注意清洁之后的保湿，同时可使用含维他命A的保养品持续细致粗大毛孔问题。',
          },
        },
      },
      {
        disabled: false,
        isRequired: false,
        value: 'hd_pore_cheek',
        value_v2_hd: 'hd_pore_cheek',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.cheek.abbr',
          'Cheeks'
        ),
        labelI18n: {
          en: 'Cheeks',
          fr: 'Joues',
          ja: '頬の毛穴',
          'zh-Hant': '臉頰',
          'zh-Hans': '脸颊',
          ko: '볼',
          de: 'Wangen',
          es: 'Mejillas',
          it: 'Guance',
          pt: 'Bochechas',
          ar: 'الخدود',
        },
        desc: {
          en:
            'AI algorithm analyzes visible pores on the cheeks, offering a severity score to help users evaluate the condition of pores in this region.',
          fr:
            'L’algorithme d’IA analyse les pores visibles sur les joues et propose un score de gravité pour aider les utilisatrices à évaluer l’état des pores dans cette région.',
          ja:
            'AIのアルゴリズムが頬にある目立ちやすい毛穴を見つけ、この範囲の毛穴について認識できるように点数をつけます。',
          cht:
            'AI 演算法能分析臉頰上的粗大毛孔，提供嚴重程度評分，幫助使用者評估這個區域的毛孔狀況。',
          chs:
            '人工智能算法可分析脸颊上的可见毛孔，提供严重程度评分，帮助用户评估该区域的毛孔状况。',
          ko:
            'AI 알고리즘이 볼에서 눈에 띄는 모공을 분석하여 심각도 점수를 제공합니다. 이를 통해 사용자가 이 부위의 모공 상태를 평가하고 적절한 관리를 할 수 있도록 돕습니다.',
          de:
            'Der KI-Algorithmus analysiert die sichtbaren Poren auf den Wangen und bietet einen Schweregrad-Score, der dem Benutzer hilft, den Zustand der Poren in diesem Bereich zu beurteilen.',
          es:
            'El algoritmo de IA analiza los poros visibles en las mejillas, ofreciendo una puntuación de gravedad para ayudar a los usuarios a evaluar el estado de los poros en esta zona.',
          it:
            "L'algoritmo AI analizza i pori visibili sulle guance, valutandoli in base a una scala che aiuta l'utente a comprendere la portata del problema nell'area.",
          pt:
            'O algoritmo de IA analisa os poros visíveis nas bochechas, oferecendo uma pontuação de gravidade ajudando os usuários a avaliar a condição dos poros nessa região.',
          ar:
            'تقوم خوارزمية الذكاء الاصطناعي بتحليل المسام المرئية على الخدين، وتوفر درجة شدة لمساعدة المستخدمين على تقييم حالة المسام في هذه المنطقة.',
        },
        resultDesc: {
          enu: {
            good:
              "Someone's mastered beautiful complexion! Keep up the great work.",
            average:
              'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
            notGood:
              'To help declog pores use a gentle cleanser twice daily and opt for non-comedogenic skin care and makeup products.',
          },
          fra: {
            good:
              'Vous savez être maîtresse de votre teint. Continuez comme ça.',
            average:
              'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
            notGood:
              'Pour déboucher vos pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soin et pour du maquillage non-comédogènes.',
          },
          jpn: {
            good:
              '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
            average:
              '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
            notGood:
              '1日2回、肌に優しい洗顔料で毛穴の汚れを落とし、ニキビになりにくいノンコメドジェニックのスキンケアや化粧品を選びましょう。',
          },
          cht: {
            good:
              '膚質看起來很精緻幾乎零毛孔，記得持續做好保濕與防曬，避免油脂過度堆積。愛曬太陽又不防曬的人毛孔絕對會越來越粗大，因為紫外線會破壞肌底膠原蛋白，使皮膚老化鬆弛，因此，一年四季都要擦防曬。',
            average:
              '油性肌膚出油過多與老廢角質堆積，固化的皮脂進而形成白頭與黑頭粉刺，毛囊內部因長期受到擠壓而顯得粗大。使用含適當濃度的酸類產品煥膚，發揮控油、代謝老化角質等作用便能改善毛孔粗大問題。',
            notGood:
              '除了痘疤還伴隨著老化型毛孔，尤其兩頰毛孔更為明顯，除了醫學美容之外，平日保養加強去角質等深層清潔，老化型毛孔則要更注意清潔之後的保濕，同時可使用含維他命A的保養品持續細緻粗大毛孔問題。',
          },
          chs: {
            good:
              '肤质看起来很精致几乎零毛孔，记得持续做好保湿与防晒，避免油脂过度堆积。爱晒太阳又不防晒的人毛孔绝对会越来越粗大，因为紫外线会破坏肌底胶原蛋白，使皮肤老化松弛，因此，一年四季都要擦防晒。',
            average:
              '油性肌肤出油过多与老废角质堆积，固化的皮脂进而形成白头与黑头粉刺，毛囊内部因长期受到挤压而显得粗大。使用含适当浓度的酸类产品焕肤，发挥控油、代谢老化角质等作用便能改善毛孔粗大问题。',
            notGood:
              '除了痘疤还伴随着老化型毛孔，尤其两颊毛孔更为明显，除了医学美容之外，平日保养加强去角质等深层清洁，老化型毛孔则要更注意清洁之后的保湿，同时可使用含维他命A的保养品持续细致粗大毛孔问题。',
          },
        },
      },
    ],
  },
  {
    disabled: false,
    value: 'dark_circle_v2',
    value_v2: 'darkCircle',
    value_v2_hd: 'hd_dark_circle',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.dark.circle',
      'Dark Circles'
    ),
    labelI18n: {
      en: 'Dark Circles',
      fr: 'Cernes',
      ja: 'くま',
      'zh-Hant': '黑眼圈',
      'zh-Hans': '黑眼圈',
      ko: '다크 서클',
      de: 'Augenringe',
      es: 'Ojeras',
      it: 'Occhiaie',
      pt: 'Círculos Escuros',
      ar: 'هالات سوداء',
    },
    desc: {
      en:
        'AI algorithm scans the under-eye area for dark circles. The dark circle area is clearly marked and users can see the severity of this condition.',
      fr:
        "L'algorithme en IA identifie les cernes. La zone sombre est clairement représentée et l'utilisateur peut évaluer la sévérité des cernes.",
      ja:
        'AI アルゴリズムは、目の下のエリアをスキャンしてクマを検出します。クマは分かり易くマークが付けられるため、ユーザーは状態を明確に把握できます。',
      cht:
        'AI 演算法會檢測黑眼圈區域，有黑眼圈的區域會被清楚地標記，用戶也可以看到黑眼圈的嚴重程度。',
      chs:
        'AI 算法扫描眼下区域的黑眼圈。黑眼圈区域被清晰地标记出来，用户可以看到黑眼圈的严重程度。',
      ko:
        'AI 알고리즘이 눈 아랫부분을 스캔하여 다크서클을 확인합니다. AR을 통해 피부 고민 부위가 명확하게 표시되어 상태의 심각도를 볼 수 있습니다.',
      de:
        'Der KI Algorithmus scannt den Bereich unter den Augen nach Augenringe ab. Der Bereich wird klar markiert und Nutzer:innen können sehen, wie schlimm der Zustand ist.',
      es:
        'Las ojeras son identificadas mediante el algoritmo de IA el cual escanea la zona de debajo de los ojos en busca de ojeras. La zona de las ojeras se marca claramente y los usuarios pueden ver la gravedad de esta condición.',
      it:
        'Rilevamento avanzato dei tre diversi tipi di occhiaie, compresi pigmentazione, vascolarizzazione e i tipi strutturali.',
      pt:
        'O algoritmo de IA verifica a área sob os olhos em busca de olheiras. A área do círculo escuro está claramente marcada e @s usuári@s podem ver a gravidade dessa condição.',
    },
    resultDesc: {
      enu: {
        good:
          'Continue to get your beauty rest! Your skin is looking healthy and refreshed.',
        average:
          'First take a deep breathe and feel the weight being lifted off your shoulders. Then dab an antioxidant-rich cream undereyes to help stimulate and brighten the area.',
        notGood:
          'It might be time to look for a retinoid to help stimulate collagen production and restore volume and firmness in the sensitive skin below your eyes. This will help to improve any undereye darkness.',
      },
      fra: {
        good:
          'Continuez à vous reposer ! Votre peau est fraîche et en bonne santé.',
        average:
          "Prenez une grande inspiration et sentez le poids s'envoler de vos épaules. Puis appliquez une noisette de crème antioxidante sous vos yeux pour aider à illuminer cette zone.",
        notGood:
          'Il est temps de passer au rétinol pour vous aider à stimuler le collagène et restorer le volume et la fermeté de la peau sensible sous les yeux. Cela aidera à améliorer vos cernes.',
      },
      jpn: {
        good:
          '肌は健康的でリフレッシュされた状態です。引き続き、美しさを保つために睡眠を十分にとってください。',
        average:
          '抗酸化作用のあるクリームを目の下にのせることで刺激が与えられ、目の下を明るくします。',
        notGood:
          '目の下の敏感な皮膚のコラーゲン生成を促進し、たるみや肌の弾力ケアに効果的なレチノイドを使用してみてください。目の下の暗さが改善されます。',
      },
      cht: {
        good:
          '作息規律眼睛明亮的你，只需要維持基礎眼霜保養並偶爾敷敷眼膜即可。但夏天戶外陽光強烈要記得戴上太陽眼鏡，也能保護雙眼避免黑色素增生。',
        average:
          '長時間盯著手機和電腦會使眼壓變大且循環不良，黑眼圈和眼周細紋就會悄悄出現！每天早晚，在使用眼部保養品時輕輕地用指腹按壓眼周可舒緩疲勞，每週敷2次眼膜擇能幫助預防熊貓眼與眼周浮腫。',
        notGood:
          '經常熬夜的你，使用手機和電腦的時間應該也蠻長的，絕對不能忽略眼周專屬保養產品，像是幫助循環的眼部精華及修護眼霜，敷眼膜的頻率也可提高到一週2～3次。用眼每小時要休息至少5分鐘，幫眼周按按摩。',
      },
      chs: {
        good:
          '作息规律眼睛明亮的你，只需要维持基础眼霜保养并偶尔敷敷眼膜即可。但夏天户外阳光强烈要记得戴上太阳眼镜，也能保护双眼避免黑色素增生。',
        average:
          '长时间盯着手机和电脑会使眼压变大且循环不良，黑眼圈和眼周细纹就会悄悄出现！每天早晚，在使用眼部保养品时轻轻地用指腹按压眼周可舒缓疲劳，每周敷2次眼膜也能帮助预防熊猫眼与眼周浮肿。',
        notGood:
          '经常熬夜的你，使用手机和计算机的时间应该也蛮长的，绝对不能忽略眼周专属保养产品，像是帮助循环的眼部精华及修护眼霜，敷眼膜的频率也可提高到一周2～3次。用眼每小时要休息至少5分钟，帮眼周按按摩。',
      },
    },
  },
  {
    disabled: false,
    value: 'radiance',
    value_v2: 'radiance',
    value_v2_hd: 'hd_radiance',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.radiance',
      'Radiance'
    ),
    labelI18n: {
      en: 'Radiance',
      fr: 'Eclat',
      ja: 'ツヤ',
      'zh-Hant': '光澤度',
      'zh-Hans': '光泽度',
      ko: '광채',
      de: 'Glanz',
      es: 'Brillo',
      it: 'Radiosità',
      pt: 'Brilho',
      ar: 'تألق',
    },
    desc: {
      en:
        'AI algorithm analyzes overall skin clarity and luminosity to provide an assessment score, helping user to improve the appearance of radiant skin.',
      fr:
        "L'algorithme en IA évalue la clareté et la luminosité de la peau afin d'aider l'utilisateur à améliorer l'apparence de sa peau.",
      ja:
        'AI アルゴリズムは、全体的な肌の透明度、明るさ、変色を分析して、スコアで評価します。',
      cht:
        'AI 演算法能分析整體肌膚的光澤和亮度，提供評估分數，幫助用戶改善膚況，更加容光煥發。',
      chs: 'AI 算法分析整体皮肤的清晰度、亮度和色斑，提供分数评估。',
      ko:
        'AI 알고리즘이 전반적인 피부 투명도, 광채 및 변색을 분석하여 평가 점수를 제공합니다.',
      de:
        'Der KI-Algorithmus analysiert insgesamt die Klarheit der Haut, das Strahlen und den Farbverlust, um eine Beurteilung zu ermöglichen.',
      es:
        'El algoritmo de IA analiza la claridad y la luminosidad general de la piel para proporcionar una puntuación de evaluación, ayudando al usuario a conseguir una piel luminosa.',
      it:
        'L’algoritmo di AI analizza la trasparenza generale della pelle, la radiosità e lo scolorimento per fornire una valutazione',
      pt:
        'O algoritmo de IA analisa a clareza e a luminosidade geral da pele para fornecer uma pontuação de avaliação, ajudando@ usuári@ a melhorar a aparência da pele.',
    },
    resultDesc: {
      enu: {
        good:
          "You're glowing and gorgeous! Keep up the good work and enjoy that beautiful radiance.",
        average:
          'Clear your canvas with a gentle cleanser-morning and night- to wash away pore-clogging gunk and let your natural glow shine through.',
        notGood:
          'Cleanse, exfoliate, hydrate, and protect to revive a gorgeous glow. Look for products with star brighteners like Vitamin C and Niacinamide (vitamin B3) which help to illuminate complexion.',
      },
      fra: {
        good:
          'Vous êtes lumineuse et superbe. Continuez comme ça et apréciez ce teint lumineux.',
        average:
          "Le matin et le soir, appliquez un nettoyant doux pour nettoyer vos pores et permettre à votre visage d'être naturellement lumineux.",
        notGood:
          'Nettoyez, exfoliez, hydratez et protégez pour raviver votre teint. Cherchez des produits qui comportent de la Vitamine C ou de la Niacinamide (Vitamine B3) qui aideront à illuminer votre teint.',
      },
      jpn: {
        good:
          'ツヤのある肌です。今のスキンケアを続けて、その状態をキープしてください。',
        average:
          '朝晩の洗顔で、毛穴の汚れを洗い流し、自然な輝きをキープしましょう。',
        notGood:
          'クレンジング、角質ケア、水分補給、保護で肌に健康的な輝きを取り戻しましょう。顔色を明るくするビタミンCやナイアシンアミド（ビタミンB3）などの美白成分が配合された製品をお勧めします。',
      },
      cht: {
        good:
          '肌膚表面油水平衡超完美，可以均勻反射出光采。比起保養更重要的是清潔，洗臉的水溫記得不能比膚溫高，用洗面產品的泡沫溫和按摩肌膚持續至少一分鐘，讓清潔成分有效發揮作用再清洗即可。',
        average:
          '局部黯沉但困擾不大，除了清潔之外，可一週使用2～3次去角質產品加強老廢角質的排除，並選擇深度保濕產品讓肌膚充滿水分自然就能折射出健康光采。',
        notGood:
          '膚色蠟黃黯沉如影隨行，看起來精神欠佳！面膜可以在短時間內給予肌膚養分補充，幫助淡化色素沉澱、均勻膚色，還能發揮立即提亮的效果。根據自己的膚質（中/混和/乾/敏感性）來選擇，才能達到最理想的效果。',
      },
      chs: {
        good:
          '肌肤表面油水平衡超完美，可以均匀反射出光采。比起保养更重要的是清洁，洗脸的水温记得不能比肤温高，用洗面产品的泡沫温和按摩肌肤持续至少一分钟，让清洁成分有效发挥作用再清洗即可。',
        average:
          '局部黯沉但困扰不大，除了清洁之外，可一周使用2～3次去角质产品加强老废角质的排除，并选择深度保湿产品让肌肤充满水分自然就能折射出健康光采。',
        notGood:
          '肤色蜡黄暗沉如影随行，看起来精神欠佳！面膜可以在短时间内给予肌肤养分补充，帮助淡化色素沉淀、均匀肤色，还能发挥立即提亮的效果。根据自己的肤质（中/混和/干/敏感性）来选择，才能达到最理想的效果。',
      },
    },
  },
  {
    disabled: false,
    value_v2_hd: 'hd_teartrough',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.teartrough',
      'Tear Trough'
    ),
    labelI18n: {
      en: 'Tear Trough',
      fr: 'Sillons lacrymaux',
      ja: '目の下のクマ',
      'zh-Hant': '淚溝',
      'zh-Hans': '泪沟',
      ko: '눈물도랑',
      de: 'Tränenrinnen',
      es: 'Surco lagrimal',
      it: 'Solco lacrimale',
      pt: 'Calha lacrimal',
      ar: 'مجرى الدمع',
    },
    desc: {
      en:
        'AI algorithm detects the tear trough area under the eyes and highlights the region, displaying the severity of the condition for user review.',
      fr:
        'L’algorithme d’IA détecte la zone de la vallée des larmes sous les yeux et la met en évidence, affichant la gravité de l’état pour que l’utilisatrice puisse l’évaluer.',
      ja:
        'AIのアルゴリズムが目の下のクマを見つけ、その部分をハイライトし、ユーザー評価用に今の状態の評価を表示します。',
      cht:
        'AI 演算法能檢測眼下淚溝區，同時標出這個區域，顯示淚溝的嚴重程度供使用者參考。',
      chs:
        '人工智能算法可检测眼下泪沟区域，并突出显示该区域，同时显示严重程度方便用户了解。',
      ko:
        'AI 알고리즘이 눈 밑의 눈물고랑 부위를 감지하고 해당 영역을 강조하여 사용자에게 상태의 심각도를 표시해 줍니다.',
      de:
        'Der KI-Algorithmus erkennt den Bereich der Tränenrinne unter den Augen, hebt diesen Bereich hervor und zeigt den Schweregrad des Zustands zur Überprüfung durch den Benutzer an.',
      es:
        'El algoritmo de IA detecta la zona del surco lagrimal debajo de los ojos y resalta la zona, mostrando la gravedad del estado para que lo vea el/la usuario/a.',
      it:
        "L'algoritmo AI rileva l'area del solco lacrimale e la illumina, in modo da evidenziare i problemi presenti, perché sia più semplice individuarli.",
      pt:
        'O algoritmo de IA detecta a área do canal lacrimal sob os olhos e destaca a região, exibindo a gravidade da condição para análise do usuário.',
      ar:
        'تكتشف خوارزمية الذكاء الاصطناعي منطقة مجرى الدموع تحت العينين وتسلط الضوء على المنطقة، وتعرض مدى شدة الحالة لمراجعة المستخدم.',
    },
    resultDesc: {
      enu: {
        good:
          'You’re looking bright-eyed and well-rested! Keep up your daily skincare routine to maintain that refreshed appearance.',
        average:
          'Feeling a bit tired? Try a hydrating eye cream with ingredients like hyaluronic acid or cucumber extract to plump up the tear trough area and reduce any signs of fatigue.',
        notGood:
          'Time to address those tired under-eyes! Look for products with peptides or retinol to help stimulate collagen production and restore volume in the tear troughs, giving you a more rejuvenated appearance.',
      },
      fra: {
        good:
          'Vous avez l’air d’avoir les yeux brillants et d’être bien reposée ! Maintenez votre routine quotidienne de soins de la peau pour conserver cette apparence rafraîchie.',
        average:
          'Vous vous sentez un peu fatiguée ? Essayez une crème hydratante pour les yeux contenant des ingrédients tels que de l’acide hyaluronique ou de l’extrait de concombre pour repulper la zone de la vallée des larmes et réduire les signes de fatigue.',
        notGood:
          'Il est temps de s’occuper de ces yeux fatigués ! Recherchez des produits contenant des peptides ou du rétinol pour stimuler la production de collagène et restaurer le volume de la vallée des larmes, vous donnant ainsi une apparence plus rajeunie.',
      },
      jpn: {
        good:
          '目がパッチリして、休養十分に見えます！毎日のスキンケア習慣を続け、さわやかな外観を保ってください。',
        average:
          'お疲れですか？ヒアルロン酸やキュウリエキスなどの成分がはいったハイドレーション アイクリームをお試しいただき、目の下をふっくらとさせ、やつれた感じを薄めてはいかがですか。',
        notGood:
          '目の下のやつれ感をお手入れしましょう！ペプチドやレチノール配合の製品で、コラーゲンの生成を促進し、目の下のボリュームを戻し、若返った印象を与えます。',
      },
      cht: {
        good:
          '你看起來眼睛明亮有神，精神飽滿！繼續保持日常保養習慣，讓肌膚維持清新感覺。',
        average:
          '感覺有點疲憊嗎？試試含有玻尿酸或黃瓜萃取物的保濕眼霜，能有效滋潤淚溝部位，減少疲勞痕跡。',
        notGood:
          '是時候解決那些疲憊的眼下問題了！選擇含有胜肽或 A 醇的產品，幫助刺激膠原蛋白生成，恢復淚溝部位的飽滿感，讓你的外表更加年輕有活力。',
      },
      chs: {
        good: '您看起来眼睛明亮，精神饱满！坚持日常护肤，保持精神焕发。',
        average:
          '感觉有点疲惫？试试含有透明质酸或黄瓜萃取物等成分的保湿眼霜，让泪沟部位丰盈起来，减少疲惫感。',
        notGood:
          '是时候解决那些看似疲惫的眼袋问题了！使用含有肽或视黄醇的护肤品，刺激胶原蛋白的生成，恢复泪沟凹陷，让您看起来更加年轻。',
      },
      kor: {
        good:
          '밝고 생기 있어 보이시네요! 상쾌한 모습을 유지하려면 매일 스킨케어 루틴을 꾸준히 이어가세요.',
        average:
          '조금 피곤한 느낌이 드시나요? 히알루론산이나 오이 추출물 같은 성분이 들어간 수분감 있는 아이크림을 사용해 보세요. 눈 밑 부위를 탱탱하게 해주고 피로의 흔적을 줄이는 데 도움을 줄 거예요.',
        notGood:
          '피곤해 보이는 눈 밑을 관리할 시간이에요! 콜라겐 생성을 촉진하고 눈 밑 부위의 볼륨을 회복하는 데 도움이 되는 펩타이드나 레티놀 성분이 포함된 제품을 찾아보세요. 이를 통해 더 생기 있고 젊어진 모습을 얻을 수 있습니다.',
      },
      deu: {
        good:
          'Du siehst strahlend und ausgeruht aus! Setze deine tägliche Hautpflegeroutine fort, um ein erfrischtes Aussehen zu erhalten.',
        average:
          'Fühlst du dich ein wenig müde? Versuche es mit einer feuchtigkeitsspendenden Augencreme mit Inhaltsstoffen wie Hyaluronsäure oder Gurkenextrakt, um die Augenpartie aufzupolstern und Anzeichen von Müdigkeit zu reduzieren.',
        notGood:
          'Zeit, sich um die müden Augenpartien zu kümmern! Achte auf Produkte mit Peptiden oder Retinol, um die Kollagenproduktion anzuregen und das Volumen der Tränenrinnen wiederherzustellen, was dir ein verjüngtes Aussehen verleiht.',
      },
      esp: {
        good:
          '¡Tiene una mirada luminosa y con aspecto de haber descansado! Siga con su rutina diaria de cuidado de la piel para conservar ese aspecto renovado.',
        average:
          '¿Siente un poco de cansancio? Pruebe una crema de ojos con ingredientes como el ácido hialurónico o el extracto de pepino para rellenar la zona del surco lagrimal y reducir cualquier signo de fatiga.',
        notGood:
          '¡Es hora de tratar esas ojeras de cansancio! Busca productos con péptidos o retinol para estimular la producción de colágeno y restaurar el volumen de los surcos lagrimales, dándote un aspecto rejuvenecido.',
      },
      ita: {
        good:
          'Hai un aspetto luminoso e riposato! Segui la tua routine di bellezza quotidiana per mantenere questo aspetto radioso.',
        average:
          "Avverti un po' di stanchezza? Prova una crema idratante per il contorno occhi, con ingredienti come l'acido ialuronico o l'estratto di cetriolo, per rimpolpare l'area del solco lacrimale e ridurre eventuali segni di stanchezza.",
        notGood:
          'È il momento di prenderti cura delle occhiaie! Cerca prodotti che contengano peptidi o retinolo che aiutano a stimolare la produzione di collagene e rivitalizzare il contorno occhi, per un aspetto più tonico e fresco.',
      },
      ptb: {
        good:
          'Você está com os olhos brilhantes e bem descansado! Mantenha sua rotina diária de cuidados com a pele para ter a aparência renovada.',
        average:
          'Está se sentindo cansado? Experimente um creme hidratante para os olhos com ingredientes como ácido hialurônico ou extrato de pepino para preencher a área do canal lacrimal e reduzir os sinais de fadiga.',
        notGood:
          'É hora de tratar dessas olheiras! Procure produtos com peptídeos ou retinol ajudando a estimular a produção de colágeno e restaurar o volume nos canais lacrimais, proporcionando uma aparência mais rejuvenescida.',
      },
      ara: {
        good:
          'أنت تبدو مضيئ العينين ومرتاحًا تمامًا! استمري في اتباع روتين العناية اليومي بالبشرة للحفاظ على هذا المظهر المتألق.',
        average:
          'هل تشعر بالتعب قليلا؟ جربي كريم ترطيب العين الذي يحتوي على مكونات مثل حمض الهيالورونيك أو مستخلص الخيار لترطيب منطقة أسفل الدموع وتقليل أي علامات للإرهاق.',
        notGood:
          'حان الوقت لمعالجة تلك الهالات السوداء نتجة الإجهاد تحت العينين! ابحثي عن المنتجات التي تحتوي على الببتيدات أو الريتينول للمساعدة في تحفيز إنتاج الكولاجين واستعادة الحجم في مناطق الدموع، مما يمنحك مظهرًا أكثر تجددًا.',
      },
    },
  },
];

export default {
  getSkinDetectionSubOptionLabel: function(parentValue, itemValue) {
    const skinDetectionCategories = this.getSkinDetectionCategories();
    const parentInfo = skinDetectionCategories.find(
      i => i.value_v2_hd === parentValue
    );
    const parentLabel = _get(parentInfo, 'labelI18n');
    if (!parentInfo.options) {
      return parentLabel;
    }

    const itemLabel = _get(
      parentInfo.options.find(i => i.value === itemValue),
      'labelI18n'
    );

    if (!itemLabel) {
      return parentLabel;
    }

    return itemLabel;
  },
  getSkinRecommendCategory: () => [
    {
      disabled: false,
      value: 'routineRecommend',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.recommendation.category.routine',
        'Routines'
      ),
    },
    {
      disabled: false,
      value: 'productRecommend',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.recommendation.category.product',
        'Products'
      ),
    },
    {
      disabled: false,
      value: 'treatmentRecommend',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.recommendation.category.treatment',
        'Treatment'
      ),
    },
  ],
  getSkinRecommendLayout: () => [
    {
      disabled: false,
      value: 'routineRecommend',
      label: i18n.t(
        'p.s.uiconfiguration.skincareHtmlResult.recommendation.layout.routine',
        'Routine'
      ),
    },
    {
      disabled: false,
      value: 'productRecommend',
      label: i18n.t(
        'p.s.uiconfiguration.skincareHtmlResult.recommendation.layout.product',
        'Product'
      ),
    },
    {
      disabled: false,
      value: 'treatmentRecommend',
      label: i18n.t(
        'p.s.uiconfiguration.skincareHtmlResult.recommendation.layout.treatment',
        'Treatment'
      ),
    },
  ],
  getSkinDetectionCategories: () => [
    {
      disabled: false,
      value: 'age_spot',
      value_v2: 'spot',
      value_v2_hd: 'hd_spot',
      label: i18n.t(
        'u.c.skin.detection.categories.i.u.s.addoreditconfig.spots',
        'Spots'
      ),
      labelI18n: {
        en: 'Spots',
        fr: 'Tâches',
        ja: 'しみ',
        'zh-Hant': '斑點',
        'zh-Hans': '斑点',
        ko: '잡티',
        de: 'Flecken',
        es: 'Manchas',
        it: 'Macchie',
        pt: 'Pontos',
        ar: 'تصبغات',
      },
      desc: {
        en:
          'The AI algorithm identifies different levels of dark spots and excludes non-dark-spot areas like skin mole, facial hair, or other false readings.',
        fr:
          "L'algorithme de l'analyseur de peau identifie l’intensité de taches et exclut ce qui ne relève pas de la tache comme les grains de beauté, les poils ou autres.",
        ja:
          'AI アルゴリズムは、異なるレベルのシミを識別し、ほくろ、うぶ毛、または誤認など、シミではないものを除外します。',
        cht:
          'AI 演算法能智慧辨識不同程度的黑斑，並排除痣、臉部毛髮或其他誤判的非黑斑區域。',
        chs:
          'AI 算法可以识别不同程度的暗斑，并排除非暗斑区域，如皮肤痣、面部毛发或其他虚假数据。',
        ko:
          'AI 알고리즘이 다양한 잡티를 식별하며, 점이나 수염, 기타 잡티가 아닌 것을 잡티로 잘못 판독하지 않도록 합니다.',
        de:
          'Der KI-Algorithmus identifiziert verschiedene Intensitäten dunkler Flecken und schließt Bereich ohne dunkle Flecken wie Muttermale, Gesichtsbehaarung oder andere falsche Werte effektiv aus.',
        es:
          'El algoritmo de IA identifica diferentes niveles de manchas en la piel desde oscuras y excluye las zonas que no lo son, como los lunares de la piel, el vello facial u otras partes de la piel.',
        it:
          'L’algoritmo tramite AI indica in maniera precisa l’area delle macchie con una sovrapposizione visiva, e determina anche la densità e l’intensità delle macchie.',
        pt:
          'O algoritmo de IA identifica diferentes níveis de manchas escuras e exclui áreas essas manchas, como verrugas na pele, pêlos faciais ou outras leituras falsas.',
      },
      resultDesc: {
        enu: {
          good:
            'Hello gorgeous! Your skin is looking mighty fine. Keep up with your daily moisturizer and SPF.',
          average:
            "Continue with twice-daily cleansing with your favorite mild cleanser and don't forget to moisturize.",
          notGood:
            'Keep your hands off your face during the day and be diligent with a gentle skincare routine including a gentle cleanser and acne spot treatment.',
        },
        fra: {
          good:
            'Votre peau est superbe. Continuez à utiliser votre hydratant et protection solaire.',
          average:
            "Continuez votre routine avec un nettoyage 2 fois par jour avec votre nettoyant doux favori et n'oubliez pas l'hydratation.",
          notGood:
            "Ne touchez pas votre visage pendant la journée et soyez assidu dans votre routine visage incluant un nettoyant doux et un traitement de l'acné.",
        },
        jpn: {
          good: '肌の状態は良好です。毎日の保湿と日焼け対策を続けてください。',
          average:
            '1日2回、マイルドな洗顔料でクレンジングをし、保湿ケアも忘れずに行ってください。',
          notGood:
            '日中は顔に手を触れないようにし、肌に優しい洗顔料やニキビ用のスキンケアをこまめに行いましょう。',
        },
        cht: {
          good:
            '膚色均勻沒有斑點與瑕疵，平時防曬很到位哦！除了日常基礎保養之外，可以嘗試抗氧化修復保養，挑選添加維他命A或Ｃ的修護成分持續優化膚質，讓膚色更透亮。',
          average:
            '隱藏的斑點蠢蠢欲動，再不即刻加強防曬保護，黑色素就要浮出肌膚表面啦！這時候要用美白精華再搭配能促進色素代謝的保養品。記得白天不要使用含光敏感成分的保養品，也要少吃光敏感性食物，以免加深色素沉澱。',
          notGood:
            '已經有較為明顯的斑點，戶外需要高係數的防水型防曬；容易忽略的室內紫外線及3C產品的藍光，可以選用SPF10～15日常防曬；每天持續美白及修護保養，每週至少敷2次高效美白面膜、至少一次去角質護理。',
        },
        chs: {
          good:
            '肤色均匀没有斑点与瑕疵，平时防晒很到位哟！除日常基础护肤之外，可以尝试抗氧化修复类保养，挑选含有维生素A或Ｃ的修护成分持续优化肤质，让肤色更透亮。',
          average:
            '隐藏的斑点蠢蠢欲动，再不及时加强防晒保护，黑色素就要浮出肌肤表面啦！这时候要用美白精华再搭配能促进色素代谢的护肤品。记得白天不要使用含光敏感成分的护肤品，也要少吃光敏感性食物，以免加深色素沉淀。',
          notGood:
            '已经有较为明显的斑点，户外需要高系数的防水型防晒；容易忽略的室内紫外线及3C产品的蓝光，可以选用SPF10～15日常防晒；每天持续美白及修护保养，每周至少敷2次高效美白面膜、至少一次去角质护理。',
        },
      },
    },
    {
      disabled: false,
      value: 'redness',
      value_v2: 'redness',
      value_v2_hd: 'hd_redness',
      label: i18n.t(
        'u.c.skin.detection.categories.i.u.s.addoreditconfig.redness',
        'Redness'
      ),
      labelI18n: {
        en: 'Redness',
        fr: 'Rougeurs',
        ja: '赤み',
        'zh-Hant': '泛紅',
        'zh-Hans': '泛红',
        ko: '홍조',
        de: 'Rötungen',
        es: 'Rojeces',
        it: 'Rossore',
        pt: 'Vermelhidão',
        ar: 'احمرار',
      },
      desc: {
        en:
          'Skin redness can be caused by a variety of factors. The AI algorithm can detect subtle symptoms before the condition starts to cause irritation.',
        fr:
          "Les rougeurs ont des causes variées. L'algorithme en IA perçoit les symptômes les plus subtiles avant l'arrivée des premières irritations.",
        ja:
          '肌が赤くなるのにはさまざまな原因があります。AI アルゴリズムは、症状が悪化する前に微妙な状態を検出できます。',
        cht:
          '肌膚泛紅可能由多種因素引起，AI 演算法能夠檢測出早期泛紅徵兆，預防泛紅問題擴大。',
        chs:
          '皮肤发红可能是由各种因素所起，AI 算法可以在病情开始造成刺激之前发现细微的症状。',
        ko:
          '피부 홍조는 다양한 이유로 발생할 수 있습니다. 당사의 AI 알고리즘은 피부 문제가 시작되기 전 발생하는 미묘한 증상까지도 감지합니다.',
        de:
          'Rötungen der Haut können durch verschiedenste Faktoren hervorgerufen werden. Der KI-Algorithmus kann bereits leichte Symptome erkennen, bevor der Zustand zu Reizungen führt.',
        es:
          'El enrojecimiento de la piel puede ser causado por diversos factores. El algoritmo de IA puede detectar síntomas sutiles antes de que el enrojecimiento de la piel cause irritación.',
        it:
          "L'AI rileva le aree arrossate, rilevando condizioni tra cui rosacea, dermatite e scottature. Determina anche la densità e la gravità degli arrossamenti.",
        pt:
          'A vermelhidão da pele pode ser causada por uma variedade de fatores. O algoritmo de IA pode detectar sintomas sutis antes que a condição comece a causar irritação.',
      },
      resultDesc: {
        enu: {
          good:
            'Keep doing what your doing! Your beautiful even skintone speaks for itself.',
          average:
            'Looking to soothe some redness on the skin? Look for products with niacinamide to soothe inflammation, even skin tone, and helps strengthen skin.',
          notGood:
            'Put down the exfoliants and pick up a moisturizer. Look for products with soothing ingredients like niacinamide, licorice root, aloe, caffeine, and cucumber which help to reduce redness.',
        },
        fra: {
          good:
            'Continuez sur cette voie. Votre teint parfait en dit long sur votre routine.',
          average:
            'Vous cherchez à calmer des rougeurs? Appliquez des produits à base de niacinamide pour stopper les inflamations, unifier et renforcer votre peau.',
          notGood:
            "Arrêtez l'exfoliation et optez pour l'hydratation avec des produits aux ingrédients calmants comme le niacinamide, la réglisse, l'aloë, la caféine ou le concombre pour aider à réduire les rougeurs.",
        },
        jpn: {
          good:
            '肌の色合いは良好です。今のスキンケアを続けて、色合いを維持しましょう。',
          average:
            '肌の赤みが気になります。ナイアシンアミドが配合された製品は、炎症を鎮め、肌の色を均一にし、肌の免疫を高める効果があります。',
          notGood:
            '角質除去剤の使用を控え、保湿効果の高いモイスチャライザーを使用してください。ナイアシンアミド、甘草根、アロエ、カフェイン、キュウリなど、鎮静効果のある成分が配合された製品をおすすめします。',
        },
        cht: {
          good:
            '肌膚很健壯！但隨著時間推移結構會越來越脆弱鬆散，漸漸失去防禦能力，天氣變化、污染、化學物質等都很容易影響，還是需要使用適合肌膚的保養品來建構天然防禦力，才能維持肌表的生態平衡。',
          average:
            '兩頰微微泛紅看起來雖可愛，但是毛細血管長期擴張可能形成紅斑或血絲，所以，一旦出現泛紅現象就要及時鎮靜舒緩，曬太陽後一定要做好修復並補充大量水分，同時選擇物理性防曬產品為佳。',
          notGood:
            '偏向敏感性膚質！肌膚較薄且表皮屏障較弱，建議選用通過敏感測試的產品，並且不要過度清潔，保養步驟與成分都盡量單純，使用舒緩性的化妝水或乳液即可，若有微熱、搔癢和疹塊現象，就必須暫停使用保養品，尋求皮膚科醫師的診斷！',
        },
        chs: {
          good:
            '肌肤很健壮！但随着时间推移结构会越来越脆弱松散，渐渐失去防御能力，天气变化、污染、化学物质等都很容易影响，还是需要使用适合肌肤的保养品来建构天然防御力，才能维持肌表的生态平衡。',
          average:
            '两颊微微泛红看起来虽可爱，但是毛细血管长期扩张可能形成红斑或血丝，所以，一旦出现泛红现象就要及时镇静舒缓，晒太阳后一定要做好修复并补充大量水分，同时选择物理性防晒产品为佳。',
          notGood:
            '偏向敏感性肤质！肌肤较薄且表皮屏障较弱，建议选用通过敏感测试的产品，并且不要过度清洁，保养步骤与成分都尽量单纯，使用舒缓性的化妆水或乳液即可，若有微热、搔痒和疹块现象，就必须暂停使用保养品，寻求皮肤科医师的诊断！',
        },
      },
    },
    {
      disabled: false,
      value: 'moisture',
      value_v2: 'moisture',
      value_v2_hd: 'hd_moisture',
      label: i18n.t(
        'u.c.skin.detection.categories.i.u.s.addoreditconfig.moisture',
        'Moisture'
      ),
      labelI18n: {
        en: 'Moisture',
        fr: 'Hydration',
        ja: '潤い',
        'zh-Hant': '保濕度',
        'zh-Hans': '保水度',
        ko: '수분',
        de: 'Feuchtigkeit',
        es: 'Humedad',
        it: 'Idratazione',
        pt: 'Humidade',
        ar: 'رطوبة',
      },
      desc: {
        en:
          'A sophisticated AI deep learning algorithm analyzes and detects skin hydration levels. Various indicators of skin dehydration are recognized.',
        fr:
          "Un algorithme performant de Deep Learning détecte le niveau d'hydratation de la peau. Plusieurs signaux de déshydratation sont détectés.",
        ja:
          '高性能の AI ディープラーニング アルゴリズムによる分析で肌の水分レベルを検出します。さまざまな水分不足状態が分かります。',
        cht:
          'AI 深度學習演算法能分析並檢測肌膚保濕程度，肌膚缺水的各種指標都能被偵測到。',
        chs:
          '采用先进的人工智能深度学习算法分析和检测皮肤的含水量，识别皮肤缺水的各种指标。',
        ko:
          '정교한 AI 딥러닝 알고리즘이 피부 수분기를 분석하고 감지합니다. 피부 건조와 관련된 다양한 지표를 인식하여 피부 타입 진단을 도출합니다.',
        de:
          'Ein raffinierter KI-Deep Learning Algorithmus analysiert und erkennt die Hydrierungsstufen der Haut. Es werden verschiedene Anzeichen der Dehydrierung der Haut erkannt.',
        es:
          'Un sofisticado algoritmo de aprendizaje profundo de IA analiza y detecta los niveles de hidratación de la piel. Se reconocen varios indicadores de deshidratación de la piel.',
        it:
          'L’AI rileva i diversi sintomi di disidratazione della pelle, tra cui linee sottili, rugosità, opacità e irritazione.',
        pt:
          'Um sofisticado algoritmo de aprendizado profundo de IA analisa e detecta os níveis de hidratação da pele. Vários indicadores de desidratação da pele podem ser reconhecidos.',
      },
      resultDesc: {
        enu: {
          good:
            'Hello beautiful hydrated skin! Keep up with the daily moisurizer and enjoy that dewy, suppleness.',
          average:
            'Pour yourself a glass of water and drink up! Then supplement with a daily moisturizer with hyaluronic acid, glycerin, or ceramides to help rehydrate and moisturize the skin.',
          notGood:
            "You're skin is in need of added hydration so treat yourself to a dailly moisturizer with hyaluronic acid, and a rich overnight cream to restore moisture come morning.",
        },
        fra: {
          good:
            "Quelle belle peau hydratée! Continuez avec l'hydratation quotidienne et apréciez cette douceur.",
          average:
            "Servez-vous un verre d'eau ! Prenez en complément avec un hydratant à base d'acide hyaluronique, de glycérine ou de céramides pour réhydrater votre peau.",
          notGood:
            "Votre peau a besoin d'hydratation alors offrez-vous une dose quotidienne d'hydratation à base d'acide hyaluronique ainsi qu'une crème de nuit riche pour une peau hydratée au réveil.",
        },
        jpn: {
          good:
            '肌は潤っています。毎日の保湿を続けて、潤いのある肌をキープしてください。',
          average:
            'コップ1杯の水を飲んでください。ヒアルロン酸、グリセリン、セラミドなどを配合した保湿剤で、肌に水分と潤いを補いましょう。',
          notGood:
            'ヒアルロン酸入りの日中用モイスチャライザーと、保湿効果の高いナイトクリームを使用し、肌に潤いを与えましょう。',
        },
        cht: {
          good:
            '你的肌膚水潤光滑，擁有健康的油水平衡又飽滿有彈性！日常的保濕產品要繼續使用，每週至少一次去角質護理並搭配抗氧化精華，能提供更適當的保護及防禦。',
          average:
            '保水度還有提升的空間哦！日常保養除了持續補水鎖水的精華液之外，可再加一道高保濕乳液預防水分流失。注意不要過度清潔，中午午休後、補妝前可以噴些保濕噴霧，並記得用面紙按掉多餘水分，每週敷2～3次面膜以提升肌膚保水度。',
          notGood:
            '保水度明顯不夠，有可能出現乾紋或敏感等問題！先以精華類產品能深度補充水分，再以高保濕乳液或乳霜形成鎖水膜預防水分流失，且每天至少喝8杯水，不定時補充保濕噴霧，且每週至少敷3次保濕面膜。',
        },
        chs: {
          good:
            '你的肌肤水润光滑，拥有健康的油水平衡又饱满有弹性！日常的保湿产品要继续使用，每周至少一次去角质护理并搭配抗氧化精华，能提供更适当的保护及防御。',
          average:
            '保水度还有提升的空间哦！日常护肤除了持续补水锁水的精华液之外，可再加一道高保湿乳液预防水分流失。注意不要过度清洁，中午午休后、补妆前可以喷些保湿喷雾，并记得用面纸按掉多余水分，每周敷2～3次面膜以提升肌肤保水度。',
          notGood:
            '保水度明显不够，有可能出现干纹或敏感等问题！先以精华类产品能深度补充水分，再以高保湿乳液或乳霜形成锁水膜预防水分流失，且每天至少喝8杯水，不定时补充保湿喷雾，且每周至少敷3次保湿面膜。',
        },
      },
    },
    {
      disabled: false,
      value: 'oiliness',
      value_v2: 'oiliness',
      value_v2_hd: 'hd_oiliness',
      label: i18n.t(
        'u.c.skin.detection.categories.i.u.s.addoreditconfig.oiliness',
        'Oiliness'
      ),
      labelI18n: {
        en: 'Oiliness',
        fr: 'Peau grasse',
        ja: '油分',
        'zh-Hant': '油光',
        'zh-Hans': '油份',
        ko: '유분',
        de: 'Öligkeit',
        es: 'Oleosidad',
        it: 'Oleosità',
        pt: 'Oleosidade',
        ar: 'دهنية',
      },
      desc: {
        en:
          'AI algorithm categorizes oiliness into three levels and shows results using AR overlays to help users recognize skin areas requiring more attention.',
        fr:
          'Notre algorithme en IA détecte 3 niveaux de brillances et les visualise par superposition grâce à la RA qui délimite les zones concernées.',
        ja:
          'AIアルゴリズムは油分を3つのレベルに分類し、AR オーバーレイで表示することで、ユーザーに注意エリアを分かり易く提示します。',
        cht:
          'AI 演算法會將出油情況分為三個等級，並透過 AR 疊加顯示結果，幫助用戶辨識需要更多關注的肌膚區域。',
        chs:
          'AI 算法将出油情况分为三个等级，并使用 AR技术 叠加显示结果，帮助用户识别需要更多关注的皮肤区域。',
        ko:
          'AI 알고리즘이 피부의 유분기를 측정하여 AR을 통해 피부 고민을 시각화하고 피부 타입 진단을 도출합니다.',
        de:
          'Der KI-Algorithmus kategorisiert die Fettigkeit der Haut in drei Stufen und zeigt die Ergebnisse anhand unserer intuitiven AR-Überlappungen auf, um den Nutzer:innen zu helfen, spezifische Hautbereiche zu erkennen, die mehr Aufmerksamkeit brauchen.',
        es:
          'La piel grasa es identificada mediante el algoritmo de IA la cual clasifica la grasa de la piel en tres niveles y muestra los resultados mediante superposiciones de RA para ayudar a los usuarios a reconocer las zonas de la piel que requieren más atención.',
        it:
          'Gli utenti possono vedere quali aree del loro viso hanno un’eccessiva secrezione di sebo.',
        pt:
          'O algoritmo de IA categoriza a oleosidade em três níveis e mostra resultados usando sobreposições de RA para ajudar @s usuári@s a reconhecer áreas da pele que exigem mais atenção.',
      },
      resultDesc: {
        enu: {
          good:
            "Looks like you're shining in all the right places! Keep up the good work and glow away!",
          average:
            "Battling a little too much shine? Try a cleanser with Salicylic Acid that gently exfoliates to clear pores, but won't dry out your skin.",
          notGood:
            'Consider a skin toner with ingredients like alpha hydroxy acids to help regulate oil production and combat excessive oiliness. A charcoal mask also helps draw out impurities causing extra shine.',
        },
        fra: {
          good:
            'Vous êtes resplendissante là où il faut. Continuez à faire les bons gestes pour être lumineuse.',
          average:
            "Un peu trop de brillance? Essayez un nettoyant avec de l'acide salicylique qui exfolit en douceur, nettoie les pores sans assécher la peau.",
          notGood:
            'Des ingrédients comme les acides alpha hydroxilés aident à réguler la production de sébum et à combattre les brillances.Un masque au charbon peut aussi retirer les impuretés.',
        },
        jpn: {
          good: '適切な油分が保たれています。その状態をキープしてください。',
          average:
            '少しテカリが気になるようです。サリチル酸が配合された洗顔料は、毛穴の汚れをやさしく取り除き、肌の乾燥を防ぎます。',
          notGood:
            'α-ヒドロキシ酸などの成分が含まれた化粧水は、皮脂の過剰分泌を防ぎます。また、炭入りのフェイスパックは、余分なテカリの原因となる不純物を取り除きます。',
        },
        cht: {
          good:
            '控油能力棒棒der！頂多春夏季偶爾在額頭鼻部及下巴有小小的出油現象，局部使用控油產品就可以。除了日常保養還可以嘗試更高效的深層清潔或煥膚精華和麵膜等產品。',
          average:
            '我相信你的控油還可以做得更好！目前T區（額頭、鼻及下巴）偏油，兩頰卻有可能偏乾幹，可選擇為混合性皮膚設計的控油產品，以及不會阻塞毛孔的保濕、防曬及粉底彩妝，恢復本身天然的油水平衡。',
          notGood:
            '中東油田就是你！保養時可選擇適合油性及痘痘肌的無油配方，底妝以霧光且具皮脂調節作用的為佳。少碰甜食和高糖飲料，也不要熬夜讓心情放輕鬆。',
        },
        chs: {
          good:
            '控油能力棒棒der！顶多春夏季偶尔在额头鼻部及下巴有小小的出油现象，局部使用控油产品就可以。除了日常护肤还可以尝试更高效的深层清洁或焕肤精华和面膜等产品。',
          average:
            '我相信你的控油还可以做得更好！目前T区（额头、鼻及下巴）偏油，两颊却有可能偏干，可选择为混合性皮肤设计的控油产品，以及不会阻塞毛孔的保湿、防晒及粉底彩妆，恢复本身天然的油水平衡。',
          notGood:
            '中东油田就是你！保养时可选择适合油性及痘痘肌的无油配方，底妆以雾光且具皮脂调节作用的产品为佳。少碰甜食和高糖饮料，也不要熬夜让心情放轻松。',
        },
      },
    },
    {
      disabled: false,
      value: 'wrinkle',
      value_v2: 'wrinkle',
      value_v2_hd: 'hd_wrinkle',
      label: i18n.t(
        'u.c.skin.detection.categories.i.u.s.addoreditconfig.wrinkles',
        'Wrinkles'
      ),
      labelI18n: {
        en: 'Wrinkles',
        fr: 'Rides',
        ja: 'しわ',
        'zh-Hant': '皺紋',
        'zh-Hans': '皱纹',
        ko: '주름',
        de: 'Falten',
        es: 'Arrugas',
        it: 'Rughe',
        pt: 'Rugas',
        ar: 'تجاعيد',
      },
      desc: {
        en:
          'AI identifies various types of wrinkles, from fine lines to deep creases. The technology focuses on facial areas where the wrinkles are most common.',
        fr:
          "L'IA identifie les différentes types de rides (des ridules aux rides profondes) et s'attarde sur les zones les plus fréquemment touchées.",
        ja:
          'AI は細いシワから深いシワまで、あらゆるシワを識別します。この技術は、シワが最も気になる顔の部分を中心に検出します。',
        cht:
          'AI 引擎能識別不同類型的皺紋，從淺層細紋到深層皺紋。此技術著重在皺紋最常出現的臉部區域。',
        chs:
          'AI 可以识别各种类型的皱纹，从细纹到深皱纹。该技术专注于识别面部最易出现皱纹的区域。',
        ko:
          'AI가 잔주름부터 깊은 주름까지 다양한 유형의 주름을 식별합니다. 해당 기술은 주름이 일반적으로 많이 나타나는 부위에 더욱 집중합니다.',
        de:
          'Der KI-Algorithmus identifiziert diverse Arten von Falten – von feinen Fältchen bis hin zu tiefen Falten. Die Technologie konzentriert sich auf Gesichtsbereiche, wo Falten am häufigsten auftreten.',
        es:
          'La IA identifica varios tipos de arrugas, y los usuarios pueden ver arrugas online desde líneas finas hasta pliegues profundos. La tecnología se centra en las zonas del rostro donde las arrugas son más frecuentes.',
        it:
          'L’AI riconosce il livello di gravità dei diversi tipi di rughe, comprese le linee della fronte, le zampe di gallina, le rughe di espressione, le rughe della marionetta e altre.',
        pt:
          'A IA identifica vários tipos de rugas, desde linhas finas até vincos profundos. A tecnologia se concentra nas áreas faciais onde as rugas são mais comuns.\n',
      },
      resultDesc: {
        enu: {
          good:
            "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
          average:
            'The sun wreaks havoc on your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
          notGood:
            'Look for products with Hyaluronic Acid. This super-hydrator holds 1,000 times its weight in water helping to replenish skin moisture and restore a plump, smooth appearance.',
        },
        fra: {
          good:
            "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
          average:
            "Le soleil fait des dégats sur votre peau et la protection solaire est votre défense n°1. Adoptez au minimum un SPF30 et renouvelez l'application fréquemment.",
          notGood:
            "Trouvez des produits avec de l'acide hyaluronique. Ce superbe hydratant retient plus de mille fois son poids en eau pour aider à hydrater votre peau et à retrouver une peau lisse et rebondie.",
        },
        jpn: {
          good:
            '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
          average:
            '太陽の紫外線は肌にダメージを与えます。SPF30以上の日焼け止めを選び、こまめに塗りなおしてください。',
          notGood:
            'ヒアルロン酸が配合された製品をおすすめします。ヒアルロン酸は1,000倍の水を保持し、角質層の水分量を高め、ふっくらとした滑らかな肌を取り戻します。',
        },
        cht: {
          good:
            '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
          average:
            '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
          notGood:
            '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
        },
        chs: {
          good:
            '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
          average:
            '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
          notGood:
            '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
        },
      },
      options: [
        {
          disabled: false,
          isRequired: true,
          value: 'hd_wrinkle',
          value_v2_hd: 'hd_wrinkle',
          label: i18n.t(
            'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.full.face.abbr',
            'Full Face'
          ),
          labelI18n: {
            en: 'Wrinkles Full Face',
            fr: 'Rides du visage',
            ja: 'シワだらけの海',
            'zh-Hant': '全臉皺紋',
            'zh-Hans': '全脸皱纹',
            ko: '얼굴 전체 주름',
            de: 'Falten Vollgesicht',
            es: 'Arrugas en todo el rostro',
            it: 'Rughe su tutto il viso',
            pt: 'Rugas no rosto inteiro',
            ar: 'التجاعيد في كامل الوجه',
          },
          desc: {
            en:
              'AI identifies various types of wrinkles, from fine lines to deep creases. The technology focuses on facial areas where the wrinkles are most common.',
            fr:
              "L'IA identifie les différentes types de rides (des ridules aux rides profondes) et s'attarde sur les zones les plus fréquemment touchées.",
            ja:
              'AI は細いシワから深いシワまで、あらゆるシワを識別します。この技術は、シワが最も気になる顔の部分を中心に検出します。',
            cht:
              'AI 引擎能識別不同類型的皺紋，從淺層細紋到深層皺紋。此技術著重在皺紋最常出現的臉部區域。',
            chs:
              'AI 可以识别各种类型的皱纹，从细纹到深皱纹。该技术专注于识别面部最易出现皱纹的区域。',
            ko:
              'AI가 잔주름부터 깊은 주름까지 다양한 유형의 주름을 식별합니다. 해당 기술은 주름이 일반적으로 많이 나타나는 부위에 더욱 집중합니다.',
            de:
              'Der KI-Algorithmus identifiziert diverse Arten von Falten – von feinen Fältchen bis hin zu tiefen Falten. Die Technologie konzentriert sich auf Gesichtsbereiche, wo Falten am häufigsten auftreten.',
            es:
              'La IA identifica varios tipos de arrugas, y los usuarios pueden ver arrugas online desde líneas finas hasta pliegues profundos. La tecnología se centra en las zonas del rostro donde las arrugas son más frecuentes.',
            it:
              'L’AI riconosce il livello di gravità dei diversi tipi di rughe, comprese le linee della fronte, le zampe di gallina, le rughe di espressione, le rughe della marionetta e altre.',
            pt:
              'A IA identifica vários tipos de rugas, desde linhas finas até vincos profundos. A tecnologia se concentra nas áreas faciais onde as rugas são mais comuns.\n',
          },
          resultDesc: {
            enu: {
              good:
                "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
              average:
                'The sun wreaks havoc on your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
              notGood:
                'Look for products with Hyaluronic Acid. This super-hydrator holds 1,000 times its weight in water helping to replenish skin moisture and restore a plump, smooth appearance.',
            },
            fra: {
              good:
                "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
              average:
                "Le soleil fait des dégats sur votre peau et la protection solaire est votre défense n°1. Adoptez au minimum un SPF30 et renouvelez l'application fréquemment.",
              notGood:
                "Trouvez des produits avec de l'acide hyaluronique. Ce superbe hydratant retient plus de mille fois son poids en eau pour aider à hydrater votre peau et à retrouver une peau lisse et rebondie.",
            },
            jpn: {
              good:
                '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
              average:
                '太陽の紫外線は肌にダメージを与えます。SPF30以上の日焼け止めを選び、こまめに塗りなおしてください。',
              notGood:
                'ヒアルロン酸が配合された製品をおすすめします。ヒアルロン酸は1,000倍の水を保持し、角質層の水分量を高め、ふっくらとした滑らかな肌を取り戻します。',
            },
            cht: {
              good:
                '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
              average:
                '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
              notGood:
                '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
            },
            chs: {
              good:
                '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
              average:
                '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
              notGood:
                '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
            },
          },
        },
        {
          disabled: false,
          isRequired: false,
          value: 'hd_wrinkle_forehead',
          value_v2_hd: 'hd_wrinkle_forehead',
          label: i18n.t(
            'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.forehead.abbr',
            'Forehead Lines'
          ),
          labelI18n: {
            en: 'Forehead Lines',
            fr: 'Lignes du front',
            ja: 'ひたいのシワ',
            'zh-Hant': '抬頭紋',
            'zh-Hans': '抬头纹',
            ko: '이마 주름',
            de: 'Stirnfalten',
            es: 'Líneas en la frente',
            it: 'Rughe sulla fronte',
            pt: 'Linhas na testa',
            ar: 'خطوط الجبهة',
          },
          desc: {
            en:
              'AI algorithm detects fine lines and deep wrinkles on the forehead, showing their severity to help users recognize areas needing attention for smoother skin.',
            fr:
              'L’algorithme d’IA détecte les ridules et les rides profondes sur le front et indique leur gravité afin d’aider les utilisatrices à reconnaître les zones nécessitant une attention particulière pour une peau plus lisse.',
            ja:
              'AIのアルゴリズムが、ひたいの細い筋や深いしわを見つけて評価し、滑らかなお肌のために注意すべき部分を見つけるお手伝いをします。',
            cht:
              'AI 演算法能檢測額頭上的細紋和深皺紋，顯示其嚴重程度，幫助使用者辨識需要關注的區域，讓皮膚比較光滑。',
            chs:
              '人工智能算法可检测额头的细纹和深层皱纹，并显示其严重程度，帮助用户了解需要护理的部位，从而让皮肤更光滑。',
            ko:
              'AI 알고리즘이 이마의 잔주름과 깊은 주름을 감지하여 그 심각도를 사용자에게 표시합니다. 이를 통해 매끄러운 피부를 위해 집중 관리가 필요한 부위를 인지할 수 있도록 도와줍니다.',
            de:
              'Der KI-Algorithmus erkennt feine Linien und tiefe Falten auf der Stirn und zeigt deren Schweregrad an, um den Benutzern zu helfen, die Bereiche zu erkennen, die für eine glattere Haut Aufmerksamkeit benötigen.',
            es:
              'El algoritmo de IA detecta las líneas finas y las arrugas profundas de la frente, mostrando su gravedad para ayudar a los usuarios a reconocer las zonas que necesitan atención para suavizar la piel.',
            it:
              "L'algoritmo AI rileva le rughe sottili e profonde sulla fronte, mostrandole chiaramente, per aiutare l'utente a riconoscere le aree che richiedono attenzione per migliorare il tono della pelle.",
            pt:
              'O algoritmo de IA detecta linhas finas e rugas profundas na testa, mostrando sua gravidade ajudando os usuários a reconhecer as áreas que precisam de atenção para uma pele mais suave.',
            ar:
              'تكتشف خوارزمية الذكاء الاصطناعي الخطوط الدقيقة والتجاعيد العميقة على الجبهة، وتظهر شدتها لمساعدة المستخدمين على التعرف على المناطق التي تحتاج إلى الاهتمام للحصول على بشرة أكثر نعومة.',
          },
          resultDesc: {
            enu: {
              good:
                "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
              average:
                'The sun wreaks havoc on your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
              notGood:
                'Look for products with Hyaluronic Acid. This super-hydrator holds 1,000 times its weight in water helping to replenish skin moisture and restore a plump, smooth appearance.',
            },
            fra: {
              good:
                "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
              average:
                "Le soleil fait des dégats sur votre peau et la protection solaire est votre défense n°1. Adoptez au minimum un SPF30 et renouvelez l'application fréquemment.",
              notGood:
                "Trouvez des produits avec de l'acide hyaluronique. Ce superbe hydratant retient plus de mille fois son poids en eau pour aider à hydrater votre peau et à retrouver une peau lisse et rebondie.",
            },
            jpn: {
              good:
                '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
              average:
                '太陽の紫外線は肌にダメージを与えます。SPF30以上の日焼け止めを選び、こまめに塗りなおしてください。',
              notGood:
                'ヒアルロン酸が配合された製品をおすすめします。ヒアルロン酸は1,000倍の水を保持し、角質層の水分量を高め、ふっくらとした滑らかな肌を取り戻します。',
            },
            cht: {
              good:
                '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
              average:
                '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
              notGood:
                '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
            },
            chs: {
              good:
                '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
              average:
                '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
              notGood:
                '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
            },
          },
        },
        {
          disabled: false,
          isRequired: false,
          value: 'hd_wrinkle_glabellar',
          value_v2_hd: 'hd_wrinkle_glabellar',
          label: i18n.t(
            'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.glabellar.abbr',
            'Glabellar Lines'
          ),
          labelI18n: {
            en: 'Glabellar Lines',
            fr: 'Lignes glabellaires',
            ja: '眉間のしわ',
            'zh-Hant': '眉間紋',
            'zh-Hans': '眉间纹',
            ko: '미간 주름',
            de: 'Glabellafalten',
            es: 'Líneas glabelares',
            it: 'Rughe glabellari',
            pt: 'Linhas glabelares',
            ar: 'خطوط غلابيلار',
          },
          desc: {
            en:
              'AI detects wrinkles between the eyebrows, assessing severity and helping users take steps toward reducing lines.',
            fr:
              'L’IA détecte les rides entre les sourcils, évalue leur gravité et aide les utilisatrices à prendre des mesures pour les atténuer.',
            ja:
              'Aiが眉毛と眉毛の間のシワを見つけてその深さと程度を示し、それを軽減するお手入れができるようにします。',
            cht:
              'AI 能檢測眉間紋，評估其嚴重程度，幫助使用者採取措施減少皺紋的出現。',
            chs:
              '人工智能可检测眉间纹，评估严重程度，帮助用户采取措施减少皱纹。',
            ko:
              'AI가 미간 주름을 감지하여 심각도를 평가하고, 사용자에게 주름 개선을 위한 관리 방법을 제안합니다.',
            de:
              'Die KI erkennt Falten zwischen den Augenbrauen, bewertet den Schweregrad und hilft den Benutzern, Schritte zur Reduzierung der Falten zu unternehmen.',
            es:
              'La IA detecta las arrugas entre las cejas, valorando la gravedad y ayudando a los usuarios a tomar medidas para reducir las líneas de expresión.',
            it:
              "L'AI rileva le rughe tra le sopracciglia, valutandone la gravità per aiutare l'utente ad adottare le misure per contrastarle.",
            pt:
              'IA detecta rugas entre as sobrancelhas, avaliando a gravidade e ajudando os usuários a tomar medidas para reduzir as linhas.',
            ar:
              'يكتشف الذكاء الاصطناعي التجاعيد بين الحاجبين، ويقيم شدتها ويساعد المستخدمين على اتخاذ خطوات نحو تقليل الخطوط.',
          },
          resultDesc: {
            enu: {
              good:
                "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
              average:
                'The sun wreaks havoc on your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
              notGood:
                'Look for products with Hyaluronic Acid. This super-hydrator holds 1,000 times its weight in water helping to replenish skin moisture and restore a plump, smooth appearance.',
            },
            fra: {
              good:
                "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
              average:
                "Le soleil fait des dégats sur votre peau et la protection solaire est votre défense n°1. Adoptez au minimum un SPF30 et renouvelez l'application fréquemment.",
              notGood:
                "Trouvez des produits avec de l'acide hyaluronique. Ce superbe hydratant retient plus de mille fois son poids en eau pour aider à hydrater votre peau et à retrouver une peau lisse et rebondie.",
            },
            jpn: {
              good:
                '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
              average:
                '太陽の紫外線は肌にダメージを与えます。SPF30以上の日焼け止めを選び、こまめに塗りなおしてください。',
              notGood:
                'ヒアルロン酸が配合された製品をおすすめします。ヒアルロン酸は1,000倍の水を保持し、角質層の水分量を高め、ふっくらとした滑らかな肌を取り戻します。',
            },
            cht: {
              good:
                '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
              average:
                '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
              notGood:
                '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
            },
            chs: {
              good:
                '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
              average:
                '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
              notGood:
                '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
            },
          },
        },
        {
          disabled: false,
          isRequired: false,
          value: 'hd_wrinkle_periocular',
          value_v2_hd: 'hd_wrinkle_periocular',
          label: i18n.t(
            'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.periocular.abbr',
            'Periocular Lines'
          ),
          labelI18n: {
            en: 'Periocular Lines',
            fr: 'Lignes périoculaires',
            ja: '眼球周囲のライン',
            'zh-Hant': '眼周紋',
            'zh-Hans': '眼周细纹',
            ko: '눈주위 주름',
            de: 'Periokularfalten',
            es: 'Líneas perioculares',
            it: 'Rughe perioculari',
            pt: 'Linhas perioculares',
            ar: 'الخطوط المحيطة بالعين',
          },
          desc: {
            en:
              'AI algorithm detects the fine lines and wrinkles beneath the eyes, providing a severity score to help users monitor the condition of their under-eye area.',
            fr:
              'L’algorithme d’IA détecte les rides et ridules sous les yeux et fournit un score de gravité pour aider les utilisatrices à surveiller l’état de leur zone sous les yeux.',
            ja:
              'AIのアルゴリズムが目の下の細い筋や深いしわを見つけ、目の下の部分の状態をご自分で気をつけられるよう点数をつけます。',
            cht:
              'AI 演算法能檢測眼下的細紋和皺紋，提供嚴重程度評分，幫助使用者監控眼下皮膚狀況。',
            chs:
              '人工智能算法可检测眼下的细纹和皱纹，提供严重程度评分，帮助用户监测眼下区域的状况。',
            ko:
              'AI 알고리즘이 눈 밑의 잔주름과 주름을 감지하여 심각도 점수를 제공합니다. 이를 통해 사용자가 눈가 상태를 모니터링하고 적절히 관리할 수 있도록 돕습니다.',
            de:
              'Der KI-Algorithmus erkennt die feinen Linien und Falten unter den Augen und gibt einen Schweregrad an, damit die Benutzer den Zustand ihrer Augenpartie überwachen können',
            es:
              'El algoritmo de IA detecta líneas finas y arrugas debajo de los ojos, proporcionando una puntuación de gravedad para ayudar a los usuarios a supervisar el estado de la zona debajo de los ojos.',
            it:
              "L'algoritmo AI rileva le rughe sottili e più profonde nell'area sotto gli occhi, valutandole in base a una scala che aiuta l'utente a monitorarne lo stato.",
            pt:
              'O algoritmo de IA detecta as linhas finas e as rugas sob os olhos, fornecendo uma pontuação de gravidade ajudando os usuários a monitorar a condição da área sob os olhos',
          },
          resultDesc: {
            enu: {
              good:
                "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
              average:
                'The sun wreaks havoc on your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
              notGood:
                'Look for products with Hyaluronic Acid. This super-hydrator holds 1,000 times its weight in water helping to replenish skin moisture and restore a plump, smooth appearance.',
            },
            fra: {
              good:
                "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
              average:
                "Le soleil fait des dégats sur votre peau et la protection solaire est votre défense n°1. Adoptez au minimum un SPF30 et renouvelez l'application fréquemment.",
              notGood:
                "Trouvez des produits avec de l'acide hyaluronique. Ce superbe hydratant retient plus de mille fois son poids en eau pour aider à hydrater votre peau et à retrouver une peau lisse et rebondie.",
            },
            jpn: {
              good:
                '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
              average:
                '太陽の紫外線は肌にダメージを与えます。SPF30以上の日焼け止めを選び、こまめに塗りなおしてください。',
              notGood:
                'ヒアルロン酸が配合された製品をおすすめします。ヒアルロン酸は1,000倍の水を保持し、角質層の水分量を高め、ふっくらとした滑らかな肌を取り戻します。',
            },
            cht: {
              good:
                '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
              average:
                '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
              notGood:
                '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
            },
            chs: {
              good:
                '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
              average:
                '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
              notGood:
                '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
            },
          },
        },
        {
          disabled: false,
          isRequired: false,
          value: 'hd_wrinkle_crowfeet',
          value_v2_hd: 'hd_wrinkle_crowfeet',
          label: i18n.t(
            'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.crow.feet.abbr',
            "Crow's Feet"
          ),
          labelI18n: {
            en: "Crow's Feet",
            fr: 'Pattes d’oie',
            ja: '目じりの小じわ',
            'zh-Hant': '魚尾紋',
            'zh-Hans': '鱼尾纹',
            ko: '눈가의 잔주름',
            de: 'Krähenfüße',
            es: 'Patas de gallo',
            it: 'Zampe di gallina',
            pt: 'Pés de galinha',
            ar: 'خطوط متجعدة حول العينين',
          },
          desc: {
            en:
              'AI algorithm detects wrinkles at the outer corners of the eyes, showing their depth and severity to help users focus on this common wrinkle zone.',
            fr:
              'L’algorithme d’IA détecte les rides aux coins externes des yeux, en indiquant leur profondeur et leur gravité pour aider les utilisatrices à se concentrer sur cette zone de rides courante.',
            ja:
              'AIのアルゴリズムが目尻のシワを見つけ、その深さと程度を示し、シワができやすいこの部分への配慮を促します。',
            cht:
              'AI 演算法能檢測眼角皺紋，顯示皺紋的深度與嚴重程度，幫助使用者關注這個常見皺紋區。',
            chs:
              '人工智能算法可检测外眼角的皱纹，显示其深度和严重程度，帮助用户关注这一常见皱纹区域。',
            ko:
              'AI 알고리즘이 눈가 외곽의 주름을 감지하여 깊이와 심각도를 표시합니다. 이를 통해 사용자가 이 흔한 주름 부위에 집중하여 관리할 수 있도록 도와줍니다.',
            de:
              'Der KI-Algorithmus erkennt Falten an den äußeren Augenwinkeln und zeigt deren Tiefe und Schweregrad an, damit sich die Benutzer auf diese häufige Faltenzone konzentrieren können.',
            es:
              'El algoritmo de IA detecta arrugas en el contorno exterior de los ojos, mostrando su profundidad y gravedad para ayudar a los usuarios a centrarse en esta zona donde habitualmente se producen arrugas.',
            it:
              "L'algoritmo AI rileva le rughe agli angoli esterni degli occhi, mostrandone la profondità e gravità per aiutare l'utente a mettere a fuoco quest'area tipicamente soggetta alle rughe.",
            pt:
              'O algoritmo de IA detecta rugas nos cantos externos dos olhos, mostrando sua profundidade e gravidade ajudando os usuários a se concentrarem nessa zona comum de rugas.',
            ar:
              'تكتشف خوارزمية الذكاء الاصطناعي التجاعيد في الزوايا الخارجية للعينين، وتظهر عمقها وشدتها لمساعدة المستخدمين على التركيز على منطقة التجاعيد الشائعة هذه.',
          },
          resultDesc: {
            enu: {
              good:
                "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
              average:
                'The sun wreaks havoc on your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
              notGood:
                'Look for products with Hyaluronic Acid. This super-hydrator holds 1,000 times its weight in water helping to replenish skin moisture and restore a plump, smooth appearance.',
            },
            fra: {
              good:
                "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
              average:
                "Le soleil fait des dégats sur votre peau et la protection solaire est votre défense n°1. Adoptez au minimum un SPF30 et renouvelez l'application fréquemment.",
              notGood:
                "Trouvez des produits avec de l'acide hyaluronique. Ce superbe hydratant retient plus de mille fois son poids en eau pour aider à hydrater votre peau et à retrouver une peau lisse et rebondie.",
            },
            jpn: {
              good:
                '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
              average:
                '太陽の紫外線は肌にダメージを与えます。SPF30以上の日焼け止めを選び、こまめに塗りなおしてください。',
              notGood:
                'ヒアルロン酸が配合された製品をおすすめします。ヒアルロン酸は1,000倍の水を保持し、角質層の水分量を高め、ふっくらとした滑らかな肌を取り戻します。',
            },
            cht: {
              good:
                '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
              average:
                '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
              notGood:
                '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
            },
            chs: {
              good:
                '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
              average:
                '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
              notGood:
                '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
            },
          },
        },
        {
          disabled: false,
          isRequired: false,
          value: 'hd_wrinkle_nasolabial',
          value_v2_hd: 'hd_wrinkle_nasolabial',
          label: i18n.t(
            'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.nasolabial.abbr',
            'Nasolabial Folds'
          ),
          labelI18n: {
            en: 'Nasolabial Folds',
            fr: 'Plis nasolabiaux',
            ja: 'ほうれい線',
            'zh-Hant': '法令紋',
            'zh-Hans': '法令纹',
            ko: '코입술주름',
            de: 'Nasolabialfalten',
            es: 'Pliegues nasolabiales',
            it: 'Rughe nasolabiali',
            pt: 'Dobras nasolabiais',
            ar: 'الطيات الأنفية',
          },
          desc: {
            en:
              'AI algorithm detects wrinkles in the nasolabial folds, providing a severity score to help users understand the depth and prominence of these wrinkles.',
            fr:
              'L’algorithme d’IA détecte les rides dans les sillons nasogéniens et fournit un score de sévérité pour aider les utilisatrices à comprendre la profondeur et la proéminence de ces rides.',
            ja:
              'AIのアルゴリズムがほうれい線のシワを見つけ、その深さと目立ちやすやすさを認識できるように点数をつけます。',
            cht:
              'AI 演算法能檢測法令紋，提供嚴重程度評分，幫助使用者了解法令紋的深度和明顯程度。',
            chs:
              '人工智能算法可检测法令纹，提供严重程度评分，帮助用户了解法令纹的深度和严重程度。',
            ko:
              'AI 알고리즘이 코입술주름을 감지하여 깊이와 두드러짐을 이해할 수 있도록 심각도 점수를 제공합니다. 이를 통해 사용자가 해당 부위를 효과적으로 관리할 수 있도록 돕습니다.',
            de:
              'Der KI-Algorithmus erkennt Falten in den Nasolabialfalten und gibt einen Schweregrad an, der dem Benutzer hilft, die Tiefe und Ausprägung dieser Falten zu verstehen.',
            es:
              'El algoritmo de IA detecta arrugas en los pliegues nasolabiales, proporcionando una puntuación de gravedad para ayudar a los usuarios a comprender la profundidad y la importancia de estas arrugas.',
            it:
              "L'algoritmo AI rileva le rughe nell'area nasolabiale, valutandole in base a una scala che aiuta l'utente a comprenderne la profondità e l'estensione.",
            pt:
              'O algoritmo de IA detecta rugas nas dobras nasolabiais, fornecendo uma pontuação de gravidade ajudando os usuários a entender a profundidade e a proeminência dessas rugas.',
            ar:
              'تكتشف خوارزمية الذكاء الاصطناعي التجاعيد في طيات الأنف الشفوية، وتوفر درجة شدة لمساعدة المستخدمين على فهم عمق وبروز هذه التجاعيد.',
          },
          resultDesc: {
            enu: {
              good:
                "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
              average:
                'The sun wreaks havoc on your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
              notGood:
                'Look for products with Hyaluronic Acid. This super-hydrator holds 1,000 times its weight in water helping to replenish skin moisture and restore a plump, smooth appearance.',
            },
            fra: {
              good:
                "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
              average:
                "Le soleil fait des dégats sur votre peau et la protection solaire est votre défense n°1. Adoptez au minimum un SPF30 et renouvelez l'application fréquemment.",
              notGood:
                "Trouvez des produits avec de l'acide hyaluronique. Ce superbe hydratant retient plus de mille fois son poids en eau pour aider à hydrater votre peau et à retrouver une peau lisse et rebondie.",
            },
            jpn: {
              good:
                '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
              average:
                '太陽の紫外線は肌にダメージを与えます。SPF30以上の日焼け止めを選び、こまめに塗りなおしてください。',
              notGood:
                'ヒアルロン酸が配合された製品をおすすめします。ヒアルロン酸は1,000倍の水を保持し、角質層の水分量を高め、ふっくらとした滑らかな肌を取り戻します。',
            },
            cht: {
              good:
                '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
              average:
                '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
              notGood:
                '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
            },
            chs: {
              good:
                '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
              average:
                '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
              notGood:
                '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
            },
          },
        },
        {
          disabled: false,
          isRequired: false,
          value: 'hd_wrinkle_marionette',
          value_v2_hd: 'hd_wrinkle_marionette',
          label: i18n.t(
            'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.marionette.abbr',
            'Marionette Lines'
          ),
          labelI18n: {
            en: 'Marionette Lines',
            fr: 'Lignes de marionnettes',
            ja: 'マリオネットライン',
            'zh-Hant': '木偶紋',
            'zh-Hans': '木偶纹',
            ko: '입옆팔자주름',
            de: 'Marionettenfalten',
            es: 'Líneas de marioneta',
            it: 'Rughe della marionetta',
            pt: 'Linhas de marionete',
            ar: 'خطوط الدمى',
          },
          desc: {
            en:
              'AI algorithm detects wrinkles in the marionette lines, providing a severity score to help users assess the depth and visibility of these wrinkles.',
            fr:
              'L’algorithme d’IA détecte les rides dans les lignes de marionnettes et fournit un score de gravité pour aider les utilisatrices à évaluer la profondeur et la visibilité de ces rides.',
            ja:
              'AIのアルゴリズムがマリオネットラインのシワを見つけ、その深さと目立ちやすさを評価できるように点数をつけます。',
            cht:
              'AI 演算法能檢測木偶紋，提供嚴重程度評分，幫助使用者評估木偶紋的深度和可見度。',
            chs:
              '人工智能算法可检测木偶纹，并提供严重程度评分，帮助用户评估这些皱纹的深度和可见度。',
            ko:
              'AI 알고리즘이 입옆팔자주름을 감지하여 깊이와 눈에 띄는 정도를 평가할 수 있도록 심각도 점수를 제공합니다. 이를 통해 사용자가 해당 부위를 보다 효과적으로 관리할 수 있도록 돕습니다.',
            de:
              'Der KI-Algorithmus erkennt Falten in den Marionettenfalten und gibt einen Schweregrad an, der den Benutzern hilft, die Tiefe und Sichtbarkeit dieser Falten zu beurteilen.',
            es:
              'El algoritmo de IA detecta arrugas en las líneas de marioneta, proporcionando una puntuación de gravedad para ayudar a los usuarios a valorar la profundidad y la visibilidad de estas arrugas.',
            it:
              "L'algoritmo AI rileva le rughe della marionetta, valutandole in base a una scala che aiuta l'utente a comprenderne la profondità e l'estensione.",
            pt:
              'O algoritmo de IA detecta rugas nas linhas de marionete, fornecendo uma pontuação de gravidade ajudando os usuários a avaliar a profundidade e a visibilidade dessas rugas.',
            ar:
              'تكتشف خوارزمية الذكاء الاصطناعي التجاعيد في خطوط الدمى، وتوفر درجة شدة لمساعدة المستخدمين على تقييم عمق ومدى وضوح هذه التجاعيد.',
          },
          resultDesc: {
            enu: {
              good:
                "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
              average:
                'The sun wreaks havoc on your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
              notGood:
                'Look for products with Hyaluronic Acid. This super-hydrator holds 1,000 times its weight in water helping to replenish skin moisture and restore a plump, smooth appearance.',
            },
            fra: {
              good:
                "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
              average:
                "Le soleil fait des dégats sur votre peau et la protection solaire est votre défense n°1. Adoptez au minimum un SPF30 et renouvelez l'application fréquemment.",
              notGood:
                "Trouvez des produits avec de l'acide hyaluronique. Ce superbe hydratant retient plus de mille fois son poids en eau pour aider à hydrater votre peau et à retrouver une peau lisse et rebondie.",
            },
            jpn: {
              good:
                '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
              average:
                '太陽の紫外線は肌にダメージを与えます。SPF30以上の日焼け止めを選び、こまめに塗りなおしてください。',
              notGood:
                'ヒアルロン酸が配合された製品をおすすめします。ヒアルロン酸は1,000倍の水を保持し、角質層の水分量を高め、ふっくらとした滑らかな肌を取り戻します。',
            },
            cht: {
              good:
                '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
              average:
                '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
              notGood:
                '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
            },
            chs: {
              good:
                '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
              average:
                '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
              notGood:
                '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
            },
          },
        },
      ],
    },
    {
      disabled: false,
      value: 'texture',
      value_v2: 'texture',
      value_v2_hd: 'hd_texture',
      i18n: i18n.texture,
      label: i18n.t(
        'u.c.skin.detection.categories.i.u.s.addoreditconfig.texture',
        'Texture'
      ),
      labelI18n: {
        en: 'Texture',
        fr: 'Problèmes de texture',
        ja: 'キメ',
        'zh-Hant': '平滑度',
        'zh-Hans': '平滑度',
        ko: '피부결',
        de: 'Textur',
        es: 'Textura',
        it: 'Consistenza',
        pt: 'Textura',
        ar: 'ملمس',
      },
      desc: {
        en:
          'AI algorithm for texture detects bumps and dents on users’ skin and offers users an overall assessment of their skin smoothness.',
        fr:
          'Notre algorithme en IA détecte les irrégularités de la peau et évalue à quel point celle-ci est lisse.',
        ja:
          'AI アルゴリズムは、ユーザーの肌の凹凸を検出し、ユーザーの肌の全体的な滑らかさを評価します。',
        cht:
          'AI 肌膚紋理演算法可檢測出用戶肌膚上的凹凸不平處，並提供對其肌膚平滑度的整體評估。',
        chs:
          'AI 算法检测用户皮肤上的凸起和凹陷，并为用户提供对其皮肤光滑度的整体评估。',
        ko:
          'AI 알고리즘이 요철을 감지하고 피부의 매끄러운 정도를 전반적으로 평가하여 피부 타입을 진단합니다.',
        de:
          'Der KI-Algorithmus für Textur erkennt Knötchen und Vertiefungen auf der Haut der Nutzerin/des Nutzers und stellt eine Gesamtbeurteilung der Hautglätte bereit.',
        es:
          'El algoritmo de IA para identificar la textura de piel detecta protuberancias y abolladuras en la piel de los usuarios y les ofrece una evaluación general de la suavidad de su piel.',
        it:
          "La diagnostica della pelle tramite AI è in grado di classificare diversi livelli di profondità della struttura della pelle e d'individuare superfici irregolari sulla pelle.",
        pt:
          'O algoritmo de IA para textura detecta inchaços e irregularidades na pele d@s usuári@s e oferece uma avaliação geral da suavidade da pele.',
      },
      resultDesc: {
        enu: {
          good:
            "Your skin is looking good so don't forget to slather on SPF to keep that beautiful face protected.",
          average:
            "Give your skin's texture a boost with an antioxidant-rich Vitamin C serum to help repair and protect skin from the elements and give your face an instant healthy glow.",
          notGood:
            'Want to improve your skin texture? Use an exfoliant one to two times per week to gently buff away any dead skin cells and reveal a beautiful, glowy complexion.',
        },
        fra: {
          good:
            "Votre peau est magnifique alors n'oubliez pas votre protection solaire pour un visage toujours aussi protégé.",
          average:
            'Donnez un coup de fouet à votre peau avec un serum anti-oxydant riche en vitames C qui aidera à la réparer et à la protéger des aggressions extérieures pour un teint lumineux et en bonne santé.',
          notGood:
            'Vous voulez améliorer la texture de votre peau? Utilisez un exfoliant une à deux fois par semaine pour retirer les peaux mortes et dévoiler une peau lumineuse.',
        },
        jpn: {
          good:
            '肌の状態は良好です。美しい顔を守るために日焼け対策を忘れないでください。',
          average:
            '抗酸化作用のあるビタミンC美容液で肌のキメを整えてください。徐々に健康的な肌ツヤを与えます。',
          notGood:
            '肌のキメが気になります。週に1～2回、角質ケア製品で古い角質をやさしく取り除き、美しく輝く肌を手に入れましょう。',
        },
        cht: {
          good:
            '是人人稱羨的水煮蛋肌！角質代謝良好，想必平時清潔步驟有徹底執行，看不見毛孔與細紋的現象要繼續保持下去。基礎保養外再進一步加入維持肌膚微生態平衡的產品，像是酵母原液等就很適合。',
          average:
            '膚質乍看還不錯，但近看毛孔還是有些黑頭白頭粉刺，可以嘗試每週一次的深層清潔護理，或是隔週一次的低濃度果酸煥膚，精華液、乳霜與定期的面膜調理也不能少，就能讓肌膚恢復應有的柔嫩細緻。',
          notGood:
            '忙碌導致代謝循環速度低落，膚色也會黯沉少活力。老廢角質細胞堆疊造成毛孔阻塞。肌膚表面粗糙不平需要從肌底修護做起，徹底排除肌膚底層的老廢物質，記得每週至少一次深層清潔並搭配2～3次煥膚面膜。',
        },
        chs: {
          good:
            '是人人羡慕的水煮蛋肌！角质代谢良好，想必平时清洁非常彻底，看不见毛孔与细纹，要继续保持哟。基础护肤外再进一步加入维持肌肤微生态平衡的产品，如酵母原液等就很适合。',
          average:
            '肤质乍看还不错，但近看毛孔还是有些黑头、白头、粉刺，可以尝试每周一次的深层清洁护理，或是隔周一次的低浓度果酸焕肤，精华液、乳霜与定期的面膜调理也不能少，就能让肌肤恢复应有的柔嫩细致。',
          notGood:
            '忙碌导致代谢循环速度低落，肤色也会黯沉少活力。老废角质细胞堆积造成毛孔阻塞。肌肤表面粗糙不平需要从肌底修护做起，彻底排除肌肤底层的老废物质，记得每周至少一次深层清洁并搭配2～3次焕肤面膜。',
        },
      },
    },
    {
      disabled: true,
      value: 'dark_circle',
      value_v2: 'darkCircle',
      value_v2_hd: 'hd_dark_circle',
      label: i18n.t(
        'u.c.skin.detection.categories.i.skincare.dark.circles',
        'Dark Circles'
      ),
      labelI18n: {
        en: 'Dark Circles',
        fr: 'Cernes',
        ja: 'くま',
        'zh-Hant': '黑眼圈',
        'zh-Hans': '黑眼圈',
        ko: '다크 서클',
        de: 'Augenringe',
        es: 'Ojeras',
        it: 'Occhiaie',
        pt: 'Círculos Escuros',
        ar: 'هالات سوداء',
      },
      desc: {
        en:
          'AI algorithm scans the under-eye area for dark circles. The dark circle area is clearly marked and users can see the severity of this condition.',
        fr:
          "L'algorithme en IA identifie les cernes. La zone sombre est clairement représentée et l'utilisateur peut évaluer la sévérité des cernes.",
        ja:
          'AI アルゴリズムは、目の下のエリアをスキャンしてクマを検出します。クマは分かり易くマークが付けられるため、ユーザーは状態を明確に把握できます。',
        cht:
          'AI 演算法會檢測黑眼圈區域，有黑眼圈的區域會被清楚地標記，用戶也可以看到黑眼圈的嚴重程度。',
        chs:
          'AI 算法扫描眼下区域的黑眼圈。黑眼圈区域被清晰地标记出来，用户可以看到黑眼圈的严重程度。',
        ko:
          'AI 알고리즘이 눈 아랫부분을 스캔하여 다크서클을 확인합니다. AR을 통해 피부 고민 부위가 명확하게 표시되어 상태의 심각도를 볼 수 있습니다.',
        de:
          'Der KI Algorithmus scannt den Bereich unter den Augen nach Augenringe ab. Der Bereich wird klar markiert und Nutzer:innen können sehen, wie schlimm der Zustand ist.',
        es:
          'Las ojeras son identificadas mediante el algoritmo de IA el cual escanea la zona de debajo de los ojos en busca de ojeras. La zona de las ojeras se marca claramente y los usuarios pueden ver la gravedad de esta condición.',
        it:
          'Rilevamento avanzato dei tre diversi tipi di occhiaie, compresi pigmentazione, vascolarizzazione e i tipi strutturali.',
        pt:
          'O algoritmo de IA verifica a área sob os olhos em busca de olheiras. A área do círculo escuro está claramente marcada e @s usuári@s podem ver a gravidade dessa condição.',
      },
      resultDesc: {
        enu: {
          good:
            'Continue to get your beauty rest! Your skin is looking healthy and refreshed.',
          average:
            'First take a deep breathe and feel the weight being lifted off your shoulders. Then dab an antioxidant-rich cream undereyes to help stimulate and brighten the area.',
          notGood:
            'It might be time to look for a retinoid to help stimulate collagen production and restore volume and firmness in the sensitive skin below your eyes. This will help to improve any undereye darkness.',
        },
        fra: {
          good:
            'Continuez à vous reposer ! Votre peau est fraîche et en bonne santé.',
          average:
            "Prenez une grande inspiration et sentez le poids s'envoler de vos épaules. Puis appliquez une noisette de crème antioxidante sous vos yeux pour aider à illuminer cette zone.",
          notGood:
            'Il est temps de passer au rétinol pour vous aider à stimuler le collagène et restorer le volume et la fermeté de la peau sensible sous les yeux. Cela aidera à améliorer vos cernes.',
        },
        jpn: {
          good:
            '肌は健康的でリフレッシュされた状態です。引き続き、美しさを保つために睡眠を十分にとってください。',
          average:
            '抗酸化作用のあるクリームを目の下にのせることで刺激が与えられ、目の下を明るくします。',
          notGood:
            '目の下の敏感な皮膚のコラーゲン生成を促進し、たるみや肌の弾力ケアに効果的なレチノイドを使用してみてください。目の下の暗さが改善されます。',
        },
        cht: {
          good:
            '作息規律眼睛明亮的你，只需要維持基礎眼霜保養並偶爾敷敷眼膜即可。但夏天戶外陽光強烈要記得戴上太陽眼鏡，也能保護雙眼避免黑色素增生。',
          average:
            '長時間盯著手機和電腦會使眼壓變大且循環不良，黑眼圈和眼周細紋就會悄悄出現！每天早晚，在使用眼部保養品時輕輕地用指腹按壓眼周可舒緩疲勞，每週敷2次眼膜擇能幫助預防熊貓眼與眼周浮腫。',
          notGood:
            '經常熬夜的你，使用手機和電腦的時間應該也蠻長的，絕對不能忽略眼周專屬保養產品，像是幫助循環的眼部精華及修護眼霜，敷眼膜的頻率也可提高到一週2～3次。用眼每小時要休息至少5分鐘，幫眼周按按摩。',
        },
        chs: {
          good:
            '作息规律眼睛明亮的你，只需要维持基础眼霜保养并偶尔敷敷眼膜即可。但夏天户外阳光强烈要记得戴上太阳眼镜，也能保护双眼避免黑色素增生。',
          average:
            '长时间盯着手机和电脑会使眼压变大且循环不良，黑眼圈和眼周细纹就会悄悄出现！每天早晚，在使用眼部保养品时轻轻地用指腹按压眼周可舒缓疲劳，每周敷2次眼膜也能帮助预防熊猫眼与眼周浮肿。',
          notGood:
            '经常熬夜的你，使用手机和计算机的时间应该也蛮长的，绝对不能忽略眼周专属保养产品，像是帮助循环的眼部精华及修护眼霜，敷眼膜的频率也可提高到一周2～3次。用眼每小时要休息至少5分钟，帮眼周按按摩。',
        },
      },
    },
    {
      disabled: false,
      value_v2: 'eye_bag',
      value: 'eye_bag',
      value_v2_hd: 'hd_eye_bag',
      label: i18n.t(
        'u.c.skin.detection.categories.i.u.s.addoreditconfig.eyebag',
        'Eye bag'
      ),
      labelI18n: {
        en: 'Eyebag',
        fr: 'Poches sous les yeux',
        ja: '目袋',
        'zh-Hant': '眼袋',
        'zh-Hans': '眼袋',
        ko: '눈밑 지방',
        de: 'Tränensäcke',
        es: 'Bolsas de Ojos',
        it: 'Borse',
        pt: 'Olheiras',
        ar: 'أكياس تحت العين',
      },
      desc: {
        en:
          'AI algorithm for dark circles can also analyze eye bag condition. AR overlays delineate the size and the puffiness of the user’s eye bag condition.',
        fr:
          "L'algorithme en IA analyse également les poches sous les yeux. La RA permet de délimiter la taille et le côté gonflé de la poche.",
        ja:
          'AI アルゴリズムは、目袋の状態を分析することができます。AR オーバーレイで、ユーザーの目袋の大きさとむくみ状態を示します。',
        cht:
          '黑眼圈的 AI 演算法也能分析眼袋狀況，透過 AR 疊加覆蓋並標示出用戶眼袋大小和浮腫情形。',
        chs:
          '黑眼圈的 AI 算法也可分析眼袋状况。AR技术 叠加可确定眼袋状况的大小和浮肿程度。',
        ko:
          '다크서클에 사용되는 알고리즘이 눈 밑 지방 상태도 분석합니다. AR 오버레이가 개인의 눈 밑 지방 상태의 크기와 붓기를 상세하게 묘사하여 표시합니다.',
        de:
          'Der KI-Algorithmus, den wir für Augenringe anwenden, kann auch Tränensäcke erkennen. AR-Überlappungen zeichnen die Größe und die Schwellung der Tränensäcke einer Person nach.',
        es:
          'El algoritmo de IA para las ojeras también puede analizar el estado de las bolsas en los ojos. Las superposiciones de RA delinean el tamaño y la hinchazón del estado de las bolsas en los ojos del usuario.',
        it:
          'Rilevamento avanzato dei tre diversi tipi di occhiaie, compresi pigmentazione, vascolarizzazione e i tipi strutturali.',
        pt:
          'O algoritmo de IA para olheiras também pode analisar a condição de bolsa ocular. As sobreposições de AR delineiam o tamanho e o inchaço da condição da bolsa ocular d@ usuári@.',
      },
      resultDesc: {
        enu: {
          good:
            'Double down on your beauty sleep and keep up with that stress-free lifestyle! Your skin is looking gorgoues.',
          average:
            'Try a cold compress or tea bags to start--or end--the day to help to reduce under eye puffiness. Also look for products with cucumber or rose water to help hydrate and calm the area.',
          notGood:
            'Look for soothing and anti-inflammaory products with green tea or caffeine to help reduce puffiness under the senstive undereye area.',
        },
        fra: {
          good:
            'Le sommeil est important. Continuez avec cette vie sans stress. Votre peau est magnifique.',
          average:
            "Essayez une compresse froide ou des sachets de thé pour réduire les poches sous les yeux. Appliquez des produits à base de concombre ou d'eau de rose pour hydrater et calmer cette zone.",
          notGood:
            'Cherchez des produits doux et anti-inflammatoires avec du thé vert ou de la caféine pour aider à réduire le côté gonflé de la peau sensible qui se trouve sous les yeux.',
        },
        jpn: {
          good:
            '肌の状態は良好です。睡眠時間を増やして、ストレスのない生活を心がけてください。',
          average:
            '目の下のむくみを抑えるには、起床後と就寝前に冷湿布やティーバッグを使ってみましょう。また、目の下に潤いを与えて落ち着かせるために、キュウリやバラの水を使った製品もお勧めです。',
          notGood:
            '目の下のむくみを抑えるには、緑茶やカフェインが配合された鎮静・抗炎症作用のある製品を使用してください。',
        },
        cht: {
          good:
            '只有臥蠶沒有眼袋！保持每天8小時睡眠並提高睡眠的品質，睡前不要喝太多水，平時不要給自己太大的心理壓力，平常選擇眼部專用精華液輕鬆保養即可。',
          average:
            '只有早上起來時眼袋較明顯，得注意改善眼周血液循環，工作念書的空檔多做眼部穴位按摩，可以預防眼袋的惡化。挑選附按摩端的眼部專用保養品，一邊塗抹眼霜時還能加強代謝循環。',
          notGood:
            '不僅眼袋明顯，還伴隨了色素黯沉或陰影問題看起來十分老氣。但由於眼周肌膚薄且脆弱易引起刺激反應，選擇低敏型眼部保養品為佳，添加咖啡因成分的眼霜有助於排水，而胜肽等修護成分則能拉提鬆垮的線條。',
        },
        chs: {
          good:
            '只有卧蚕没有眼袋！保持每天8小时睡眠并提高睡眠的质量，睡前不要喝太多水，平时不要给自己太大的心理压力，平常选择眼部专用精华液轻松保养即可。',
          average:
            '只有早上起来时眼袋较明显，得注意改善眼周血液循环，工作念书的空档多做眼部穴位按摩，可以预防眼袋的恶化。挑选附按摩端的眼部专用保养品，一边涂抹眼霜时还能加强代谢循环。',
          notGood:
            '不仅眼袋明显，还伴随了色素暗沉或阴影问题看起来十分老气。但由于眼周肌肤薄且脆弱易引起刺激反应，选择低敏型眼部保养品为佳，添加咖啡因成分的眼霜有助于去水肿，而胜肽等修护成分则能拉提松垮的线条。',
        },
      },
    },
    ...advSkinDetectionCategories,
  ],
  getSkinDetectionSkinTypes: () => [
    {
      disabled: false,
      value_v2_hd: 'combination_non_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.combination',
        'Combination'
      ),
      labelI18n: {
        en: 'Combination',
        fr: 'Mixte',
        ja: '混合肌',
        'zh-Hant': '混合肌',
        'zh-Hans': '混合肌',
        ko: '복합성',
        de: 'Mischhaut',
        es: 'Mixta',
        it: 'Mista',
        pt: 'Mista',
        ar: 'Combination',
      },
    },
    {
      disabled: false,
      value_v2_hd: 'dry_non_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.dry',
        'Dry'
      ),
      labelI18n: {
        en: 'Dry',
        fr: 'Sèche',
        ja: '乾燥肌',
        'zh-Hant': '乾性肌',
        'zh-Hans': '干性肌',
        ko: '건성',
        de: 'Trocken',
        es: 'Seca',
        it: 'Secca',
        pt: 'Seca',
        ar: 'Dry',
      },
    },
    {
      disabled: false,
      value_v2_hd: 'oily_non_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.oliy',
        'Oily'
      ),
      labelI18n: {
        en: 'Oily',
        fr: 'Grasse',
        ja: 'オイリー肌',
        'zh-Hant': '油性肌',
        'zh-Hans': '油性肌',
        ko: '지성',
        de: 'Fettig',
        es: 'Grasosa',
        it: 'Grassa',
        pt: 'Oleosa',
        ar: 'Oily',
      },
    },
    {
      disabled: false,
      value_v2_hd: 'normal_non_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.normal',
        'Normal'
      ),
      labelI18n: {
        en: 'Normal',
        fr: 'Normale',
        ja: 'ノーマル',
        'zh-Hant': '中性肌',
        'zh-Hans': '中性肌',
        ko: '중성',
        de: 'Normal',
        es: 'Normal',
        it: 'Normale',
        pt: 'Normal',
        ar: 'Normal',
      },
    },
    {
      disabled: false,
      value_v2_hd: 'normal_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.normal.sensitive',
        'Sensitive'
      ),
      labelI18n: {
        en: 'Sensitive',
        fr: 'Sensible',
        ja: '敏感肌',
        'zh-Hant': '敏感肌',
        'zh-Hans': '敏感肌',
        ko: '민감성',
        de: 'Empfindlich',
        es: 'Sensible',
        it: 'Sensibile',
        pt: 'Sensitiva',
        ar: 'Sensitive',
      },
    },
    {
      disabled: false,
      value_v2_hd: 'dry_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.dry.sensitive',
        'Dry & Sensitive'
      ),
      labelI18n: {
        en: 'Dry & Sensitive',
        fr: 'Sèche & Sensible',
        ja: '乾燥＆敏感肌',
        'zh-Hant': '乾性敏感肌',
        'zh-Hans': '干性敏感肌',
        ko: '건성 및 민감성',
        de: 'Trocken & Empfindlich',
        es: 'Seca y sensible',
        it: 'Secca e Sensibile',
        pt: 'Seca & Sensível',
        ar: 'Dry & Sensitive',
      },
    },
    {
      disabled: false,
      value_v2_hd: 'oily_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.oily.sensitive',
        'Oily & Sensitive'
      ),
      labelI18n: {
        en: 'Oily & Sensitive',
        fr: 'Grasse & Sensible',
        ja: 'オイリー＆敏感肌',
        'zh-Hant': '油性敏感肌',
        'zh-Hans': '油性敏感肌',
        ko: '지성 및 민감성',
        de: 'Fettig & Empfindlich',
        es: 'Grasosa y sensible',
        it: 'Grassa e Sensibile',
        pt: 'Oleosa & Sensível',
        ar: 'Oily & Sensitive',
      },
    },
    {
      disabled: false,
      value_v2_hd: 'combination_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.combination.sensitive',
        'Combination & Sensitive'
      ),
      labelI18n: {
        en: 'Combination & Sensitive',
        fr: 'Mixte & Sensible',
        ja: '混合＆敏感肌',
        'zh-Hant': '混合敏感肌',
        'zh-Hans': '混合敏感肌',
        ko: '복합성 및 민감성',
        de: 'Mischhaut & Empfindlich',
        es: 'Mixta y sensible',
        it: 'Mista e Sensibile',
        pt: 'Mista & Sensível',
        ar: 'Combination & Sensitive',
      },
    },
  ],
  getSkinDetectionFacialArea: () => [
    {
      disabled: false,
      value_v2_hd: 'skin_type',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.full.face',
        'Full Face'
      ),
      labelI18n: {
        en: 'Full Face',
        fr: 'Full Face',
        ja: '顔全体',
        'zh-Hant': 'Full Face',
        'zh-Hans': 'Full Face',
        ko: 'Full Face',
        de: 'Full Face',
        es: 'Full Face',
        it: 'Full Face',
        pt: 'Full Face',
        ar: 'Full Face',
      },
    },
    {
      disabled: false,
      value_v2_hd: 't_skin_type',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.t.zone',
        'T-zone'
      ),
      labelI18n: {
        en: 'T-zone',
        fr: 'Zone T',
        ja: 'T ゾーン',
        'zh-Hant': 'T字部位',
        'zh-Hans': 'T字区',
        ko: 'T존',
        de: 'T-Zone',
        es: 'Zona T',
        it: 'Zona T',
        pt: 'Zona T',
        ar: 'T-zone',
      },
    },
    {
      disabled: false,
      value_v2_hd: 'u_skin_type',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.u.zone',
        'U-zone'
      ),
      labelI18n: {
        en: 'U-zone',
        fr: 'Zone U',
        ja: 'U ゾーン',
        'zh-Hant': 'Ｕ字部位',
        'zh-Hans': 'U字区',
        ko: 'U존',
        de: 'U-Zone',
        es: 'Zona U',
        it: 'Zona U',
        pt: 'Zona U',
        ar: 'U-zone',
      },
    },
  ],
  getSkinDetectionFacialAreaResult: () => [
    {
      disabled: false,
      value_v2_hd: 'normal',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.normal',
        'Normal'
      ),
    },
    {
      disabled: false,
      value_v2_hd: 'oily',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.oily',
        'Oily'
      ),
    },
    {
      disabled: false,
      value_v2_hd: 'dry',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.dry',
        'Dry'
      ),
    },
    {
      disabled: false,
      value_v2_hd: 'combination',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.combination',
        'Combination'
      ),
    },
  ],
  getSkinSensitivityFacialArea: () => [
    {
      disabled: false,
      value_v2_hd: 'sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.full.face',
        'Full Face'
      ),
      labelI18n: {
        en: 'Full Face',
        fr: 'Full Face',
        ja: '顔全体',
        'zh-Hant': 'Full Face',
        'zh-Hans': 'Full Face',
        ko: 'Full Face',
        de: 'Full Face',
        es: 'Full Face',
        it: 'Full Face',
        pt: 'Full Face',
        ar: 'Full Face',
      },
    },
    {
      disabled: false,
      value_v2_hd: 't_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.t.zone',
        'T-zone'
      ),
      labelI18n: {
        en: 'T-zone',
        fr: 'Zone T',
        ja: 'T ゾーン',
        'zh-Hant': 'T字部位',
        'zh-Hans': 'T字区',
        ko: 'T존',
        de: 'T-Zone',
        es: 'Zona T',
        it: 'Zona T',
        pt: 'Zona T',
        ar: 'T-zone',
      },
    },
    {
      disabled: false,
      value_v2_hd: 'u_sensitive',
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.u.zone',
        'U-zone'
      ),
      labelI18n: {
        en: 'U-zone',
        fr: 'Zone U',
        ja: 'U ゾーン',
        'zh-Hant': 'Ｕ字部位',
        'zh-Hans': 'U字区',
        ko: 'U존',
        de: 'U-Zone',
        es: 'Zona U',
        it: 'Zona U',
        pt: 'Zona U',
        ar: 'U-zone',
      },
    },
  ],
  getSkinSensitivityFacialAreaResult: () => [
    {
      disabled: false,
      value_v2_hd: true,
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.skinsensitivity.sensitive',
        'Sensitive'
      ),
    },
    {
      disabled: false,
      value_v2_hd: false,
      label: i18n.t(
        'p.s.uiconfiguration.skincaredetection.detection.description.content.skinsensitivity.non.sensitive',
        'Non-sensitive'
      ),
    },
  ],
  getParentValueByOptionValue: function(OptionValue) {
    const detectionCategories = this.getSkinDetectionCategories4MultipleVersion(
      true
    );
    for (const item of detectionCategories) {
      if (
        _get(item, 'options', []).some(option => option.value === OptionValue)
      ) {
        return item.value;
      }
    }
    return null;
  },
  getRequiredOptionValueByParentValue: function(parentValue) {
    const detectionCategories = this.getSkinDetectionCategories4MultipleVersion(
      true
    );
    const parent = detectionCategories.find(item => item.value === parentValue);
    if (!parent) return null;

    const requiredOption = parent.options.find(option => option.isRequired);
    return requiredOption ? requiredOption.value : null;
  },
  mapSdToHdDetectionReports: function(sdDatasets, mapping) {
    return sdDatasets.map(data => {
      const skincareInfo = _get(data, 'content.skincareInfo', {});
      const skinReports = _get(skincareInfo, 'skinReports', []);
      const updatedReports =
        skinReports.length > 0
          ? skinReports.map(report => ({
              ...report,
              type: mapping[report.type] || report.type,
            }))
          : [];

      const skincareMasks = _get(data, 'content.skincareMasks', {});
      const updatedSkincareMasks = smbUtils.mapToKeys(skincareMasks, mapping);
      return {
        ...data,
        content: {
          ...data.content,
          skincareInfo: {
            ...skincareInfo,
            skinReports: updatedReports,
          },
          skincareMasks: updatedSkincareMasks,
        },
      };
    });
  },
  getSdV2ToHdDetectionCategories: function(isSkinHealth = true) {
    const categories = this.getSkinDetectionCategories()
      .filter(c => c.disabled === false && c.value !== 'dark_circle')
      .reduce((acc, item) => {
        if (item.value === 'dark_circle_v2') {
          acc[item.value] = item.value_v2_hd;
        } else if (item.value_v2 && item.value_v2_hd) {
          acc[item.value_v2] = item.value_v2_hd;
        } else if (item.value_v2_hd) {
          acc[item.value_v2_hd] = item.value_v2_hd;
        }
        if (
          Array.isArray(item.options) &&
          _get(item, 'options', []).length > 0
        ) {
          item.options.forEach(opt => {
            if (opt.value_v2_hd) {
              acc[opt.value_v2_hd] = opt.value_v2_hd;
            }
          });
        }
        return acc;
      }, {});
    if (isSkinHealth) {
      categories['skin_health'] = 'skin_health';
    }
    return categories;
  },
  getSkinDetectionCategories4MultipleVersion: function(isHd = false) {
    if (isHd) {
      return this.getSkinDetectionCategories()
        .filter(s => {
          return s.disabled === false && s.value_v2_hd;
        })
        .map(c => ({
          ...c,
          value: c.value_v2_hd,
          label: c.label,
        }));
    }

    return this.getSkinDetectionCategories()
      .filter(s => s.disabled === false && s.value)
      .map(c => ({
        value: c.value,
        label: c.label,
      }));
  },
  getSkinDetectionReportConcern: function(isSkinHealth = true, isHd = false) {
    let concerns = [];
    if (isHd) {
      concerns = this.getSkinDetectionCategories()
        .filter(
          c =>
            c.value_v2_hd && c.disabled === false && c.value !== 'dark_circle'
        )
        .map(c => {
          return {
            label: c.label,
            value: c.value_v2_hd,
            options: _get(c, 'options', []).map(option => ({
              label: option.label,
              value: option.value_v2_hd,
            })),
          };
        });
    } else {
      concerns = this.getSkinDetectionCategories()
        .filter(
          c =>
            c.disabled === false &&
            ((c.value && c.value !== 'dark_circle') ||
              (c.value_v2_hd && c.value_v2_hd !== 'hd_teartrough'))
        )
        .map(c => {
          if (c.value === 'dark_circle_v2' || c.value === 'age_spot') {
            return {label: c.label, value: c.value};
          }

          return {label: c.label, value: c.value_v2};
        });
    }

    if (isSkinHealth) {
      concerns.unshift({
        value: 'skin_health',
        label: i18n.t(
          'u.c.skin.detection.categories.i.skincare.skinHealth',
          'Skin Score'
        ),
      });
    }

    return concerns;
  },
  getSkinDetectionReportFlatConcern: function(
    isSkinHealth = true,
    isHd = false,
    isSubOption = false
  ) {
    let concerns = [];

    if (isHd && isSubOption) {
      concerns = this.getSkinDetectionCategories()
        .filter(c => c.value_v2_hd && c.value !== 'dark_circle')
        .flatMap(c => {
          if (isSubOption && _get(c, 'options', []).length > 0) {
            return c.options.map(option => ({
              label: `${c.label} - ${option.label}`,
              value: option.value_v2_hd,
            }));
          }
          return {label: c.label, value: c.value_v2_hd};
        });
    } else if (isHd) {
      concerns = this.getSkinDetectionCategories()
        .filter(
          c =>
            c.disabled === false &&
            ((c.value && c.value !== 'dark_circle') ||
              (c.value_v2_hd && c.value_v2_hd !== 'hd_teartrough'))
        )
        .map(c => {
          return {label: c.label, value: c.value_v2_hd};
        });
    } else {
      concerns = this.getSkinDetectionCategories()
        .filter(
          c =>
            c.disabled === false &&
            ((c.value && c.value !== 'dark_circle') ||
              (c.value_v2_hd && c.value_v2_hd !== 'hd_teartrough'))
        )
        .map(c => {
          return c.value === 'dark_circle_v2'
            ? {label: c.label, value: c.value}
            : {label: c.label, value: c.value_v2};
        });
    }

    if (isSkinHealth) {
      concerns.push({
        value: 'skin_health',
        label: i18n.t(
          'u.c.skin.detection.categories.i.skincare.skinHealth',
          'Skin Score'
        ),
      });
    }

    return concerns;
  },
};
